import { Component, OnInit, OnDestroy, ChangeDetectorRef, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { FlashcardService, Flashcard, FlashcardCategory } from './flashcard.service';
import { MessageService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { SelectModule } from 'primeng/select';
import { DialogModule } from 'primeng/dialog';
import { PaginatorModule } from 'primeng/paginator';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-flashcard-show',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    ToastModule,
    SelectModule,
    DialogModule,
    PaginatorModule
  ],
  providers: [MessageService],
  template: `
    <p-toast></p-toast>
<p-dialog 
      header="Buat Sesi Custom" 
      [(visible)]="displayCustomSessionDialog" 
      [modal]="true" 
      [dismissableMask]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '440px', maxWidth: '95vw' }"
      appendTo="body">
      
      <div class="flex flex-col gap-4 py-1">
        <!-- TINGKAT KESULITAN Section -->
        <div class="w-full flex flex-col gap-2">
          <span class="text-xs font-semibold text-slate-500 uppercase tracking-wide">Tingkat Kesulitan</span>
          
          <div class="grid grid-cols-4 gap-2">
            <button 
              type="button"
              (click)="toggleCustomRating('ulang')"
              [class]="isCustomRatingSelected('ulang') 
                ? 'inline-flex items-center justify-center gap-1.5 px-2 py-2 bg-[#FEE2E2] border-2 border-[#EF4444] text-[#DC2626] rounded-xl text-xs font-semibold cursor-pointer transition-all active:scale-95'
                : 'inline-flex items-center justify-center gap-1.5 px-2 py-2 bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 rounded-xl text-xs font-medium cursor-pointer transition-all active:scale-95'">
              <span class="w-3.5 h-3.5 rounded bg-[#F87171] flex-shrink-0"></span>
              <span>Ulangi</span>
            </button>

            <button 
              type="button"
              (click)="toggleCustomRating('sulit')"
              [class]="isCustomRatingSelected('sulit') 
                ? 'inline-flex items-center justify-center gap-1.5 px-2 py-2 bg-[#FEF9C3] border-2 border-[#EAB308] text-[#CA8A04] rounded-xl text-xs font-semibold cursor-pointer transition-all active:scale-95'
                : 'inline-flex items-center justify-center gap-1.5 px-2 py-2 bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 rounded-xl text-xs font-medium cursor-pointer transition-all active:scale-95'">
              <span class="w-3.5 h-3.5 rounded bg-[#FBBF24] flex-shrink-0"></span>
              <span>Sulit</span>
            </button>

            <button 
              type="button"
              (click)="toggleCustomRating('baik')"
              [class]="isCustomRatingSelected('baik') 
                ? 'inline-flex items-center justify-center gap-1.5 px-2 py-2 bg-[#DCFCE7] border-2 border-[#22C55E] text-[#15803D] rounded-xl text-xs font-semibold cursor-pointer transition-all active:scale-95'
                : 'inline-flex items-center justify-center gap-1.5 px-2 py-2 bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 rounded-xl text-xs font-medium cursor-pointer transition-all active:scale-95'">
              <span class="w-3.5 h-3.5 rounded bg-[#22C55E] flex-shrink-0"></span>
              <span>Baik</span>
            </button>

            <button 
              type="button"
              (click)="toggleCustomRating('mudah')"
              [class]="isCustomRatingSelected('mudah') 
                ? 'inline-flex items-center justify-center gap-1.5 px-2 py-2 bg-[#E0F2FE] border-2 border-[#38BDF8] text-[#0369A1] rounded-xl text-xs font-semibold cursor-pointer transition-all active:scale-95'
                : 'inline-flex items-center justify-center gap-1.5 px-2 py-2 bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 rounded-xl text-xs font-medium cursor-pointer transition-all active:scale-95'">
              <span class="w-3.5 h-3.5 rounded bg-[#38BDF8] flex-shrink-0"></span>
              <span>Mudah</span>
            </button>
          </div>
        </div>

        <!-- TOPIK Section -->
        <div class="w-full flex flex-col gap-2">
          <div class="flex items-center justify-between">
            <span class="text-xs font-semibold text-slate-500 uppercase tracking-wide">Topik</span>
            <button 
              type="button"
              (click)="toggleSelectAllCustomCategories()"
              class="text-xs font-semibold text-[#4C85EC] hover:text-blue-700 bg-transparent border-none cursor-pointer">
              {{ areAllCustomCategoriesSelected ? 'Hapus Semua' : 'Pilih Semua' }}
            </button>
          </div>
          
          <!-- Custom category search bar -->
          <div class="relative w-full">
            <span class="absolute inset-y-0 left-0 flex items-center pl-3.5 pointer-events-none text-slate-400">
              <i class="pi pi-search text-xs"></i>
            </span>
            <input
              type="text"
              [(ngModel)]="customCategorySearchQuery"
              style="font-size:12px; padding: 10px 36px; border: 1px solid #e2e8f0; border-radius: 14px; width: 100%; outline: none;"
              placeholder="Cari Topik atau Kata Kunci" />
            <button 
              type="button"
              *ngIf="customCategorySearchQuery" 
              (click)="customCategorySearchQuery = ''"
              class="absolute inset-y-0 right-0 flex items-center pr-3 text-slate-400 hover:text-slate-600 bg-transparent border-none cursor-pointer">
              <i class="pi pi-times text-xs"></i>
            </button>
          </div>

          <!-- List of Topic Pills -->
          <div class="flex flex-wrap gap-2 max-h-48 overflow-y-auto pr-1 py-1">
            <button 
              type="button"
              *ngFor="let cat of filteredCustomCategories"
              (click)="toggleCustomCategory(cat.id!)"
              [class]="isCustomCategorySelected(cat.id!)
                ? 'inline-flex items-center gap-2 px-3 py-2 bg-blue-50 border-2 border-[#4C85EC] text-[#4C85EC] rounded-xl text-xs font-semibold cursor-pointer transition-all active:scale-95'
                : 'inline-flex items-center gap-2 px-3 py-2 bg-white border border-slate-200 hover:bg-slate-50 text-slate-700 rounded-xl text-xs font-medium cursor-pointer transition-all active:scale-95'">
              <span 
                class="w-4 h-4 rounded flex items-center justify-center flex-shrink-0 border"
                [style.background]="isCustomCategorySelected(cat.id!) ? '#4C85EC' : 'white'"
                [style.border-color]="isCustomCategorySelected(cat.id!) ? '#4C85EC' : '#e2e8f0'">
                <i *ngIf="isCustomCategorySelected(cat.id!)" class="pi pi-check" style="font-size:9px; color:white;"></i>
              </span>
              <span>{{ cat.name }}</span>
            </button>
            
            <div *ngIf="filteredCustomCategories.length === 0" class="text-xs text-slate-400 italic py-3 text-center w-full">
              Tidak ada topik yang cocok dengan pencarian.
            </div>
          </div>
        </div>
      </div>

      <ng-template pTemplate="footer">
        <div class="flex items-center justify-end gap-3 pt-2">
          <button 
            type="button"
            (click)="displayCustomSessionDialog = false"
            class="px-5 py-2.5 rounded-xl border-2 border-[#4C85EC] text-[#4C85EC] bg-white hover:bg-blue-50 text-xs font-bold transition-all cursor-pointer">
            Batalkan
          </button>

          <button 
            type="button"
            [disabled]="!isCustomSessionValid"
            (click)="startCustomSession()"
            class="px-5 py-2.5 rounded-xl bg-[#4C85EC] hover:bg-blue-600 text-white border-none text-xs font-bold transition-all shadow-sm cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed">
            Mulai Sesi
          </button>
        </div>
      </ng-template>
    </p-dialog>


    <!-- Category Selection (Dashboard Flashcard View matching Image 2) -->
    <div class="w-full px-0 sm:px-2 md:px-4 py-2 sm:py-4 space-y-4 sm:space-y-6" *ngIf="!selectedCategory">
      
      <!-- Top Hero Banner Card -->
      <div class="w-full bg-gradient-to-r from-[#4A86ED] via-[#3B82F6] to-[#50B2FA] rounded-2xl md:rounded-3xl p-5 sm:p-7 md:p-10 text-white shadow-md relative overflow-hidden flex items-center justify-between min-h-[110px] sm:min-h-[140px] md:min-h-[180px]">
        <div class="w-full max-w-md lg:max-w-xl z-10 py-1 sm:py-2">
          <h2 class="text-2xl sm:text-3xl md:text-4xl font-black m-0 text-white tracking-tight">Flash Card</h2>
          <p class="text-xs sm:text-sm md:text-base text-white/95 mt-1.5 sm:mt-2.5 m-0 leading-relaxed font-normal">
            Kuasai materi melalui latihan mendalam dan perbaikan secara berulang-ulang.
          </p>
        </div>

        <!-- Flashcard Image Mockup (Positioned flush at bottom right edge) -->
        <div class="absolute bottom-0 right-4 md:right-8 hidden md:block z-10 max-w-[210px] lg:max-w-[260px]">
          <img 
            src="images/flashcard_mockup.png" 
            alt="Flashcard Mockup" 
            class="w-full h-auto object-contain object-bottom drop-shadow-xl block transform translate-y-1 hover:translate-y-0 transition-transform duration-300" />
        </div>
      </div>

      <!-- Progress Section (2 Cards Grid) -->
      <div class="grid grid-cols-1 xl:grid-cols-12 gap-6">
        
        <!-- Left: Progres Global (span 5 on xl) -->
        <div class="xl:col-span-5 bg-white border border-slate-100 rounded-2xl md:rounded-3xl p-6 shadow-sm flex flex-col justify-between">
          <div class="flex items-center gap-3 mb-6">
            <svg class="w-6 h-6 text-[#4C85EC] flex-shrink-0" viewBox="0 0 24 24" fill="currentColor">
              <path d="M11 2v9h9c-.5 5-4.5 9-9 9s-9-4-9-9 4-8.5 9-9zm2 0v7h7c-.5-3.8-3.2-6.5-7-7z"/>
            </svg>
            <h3 class="text-lg md:text-xl font-bold text-slate-800 m-0">Progres Global</h3>
          </div>

          <div class="flex flex-col sm:flex-row items-center gap-6 md:gap-8 my-auto">
            <!-- Donut Chart -->
            <div class="relative w-32 h-32 sm:w-36 sm:h-36 md:w-40 md:h-40 flex-shrink-0 flex items-center justify-center">
              <svg class="w-full h-full" viewBox="0 0 120 120">
                <!-- Background Ring -->
                <circle cx="60" cy="60" r="52" stroke="#F1F5F9" stroke-width="14" fill="transparent" />
                
                <!-- Segments -->
                <!-- 1. Mudah (Sky Blue) -->
                <circle cx="60" cy="60" r="52" stroke="#29A6E8" stroke-width="14" fill="transparent"
                  [attr.stroke-dasharray]="donutSeg1.dash"
                  [attr.stroke-dashoffset]="donutSeg1.offset"
                  class="transition-all duration-700" />
                
                <!-- 2. Baik (Green) -->
                <circle cx="60" cy="60" r="52" stroke="#22C55E" stroke-width="14" fill="transparent"
                  [attr.stroke-dasharray]="donutSeg2.dash"
                  [attr.stroke-dashoffset]="donutSeg2.offset"
                  class="transition-all duration-700" />

                <!-- 3. Sulit (Yellow) -->
                <circle cx="60" cy="60" r="52" stroke="#EAB308" stroke-width="14" fill="transparent"
                  [attr.stroke-dasharray]="donutSeg3.dash"
                  [attr.stroke-dashoffset]="donutSeg3.offset"
                  class="transition-all duration-700" />

                <!-- 4. Ulangi (Red) -->
                <circle cx="60" cy="60" r="52" stroke="#EF4444" stroke-width="14" fill="transparent"
                  [attr.stroke-dasharray]="donutSeg4.dash"
                  [attr.stroke-dashoffset]="donutSeg4.offset"
                  class="transition-all duration-700" />
              </svg>

              <!-- Center Text -->
              <div class="absolute inset-0 flex flex-col items-center justify-center text-center">
                <span class="text-2xl sm:text-3xl md:text-[34px] font-black text-[#4C85EC] leading-none mb-1">
                  {{ totalStats.total || totalStats.worked || 0 }}
                </span>
                <span class="text-xs md:text-[13px] text-[#4C85EC]/85 font-medium">Total Kartu</span>
              </div>
            </div>

            <!-- Legend List -->
            <div class="flex-1 w-full space-y-3">
              
              <!-- Mudah -->
              <div class="grid grid-cols-[auto_1fr_auto] items-center gap-2 sm:gap-3">
                <div class="flex items-center gap-2.5">
                  <span class="w-3.5 h-3.5 rounded-[5px] bg-[#29A6E8] flex-shrink-0"></span>
                  <span class="font-medium text-slate-800 text-xs sm:text-sm">Mudah</span>
                </div>
                <span class="text-slate-400 text-xs font-normal text-right pr-2 whitespace-nowrap">{{ totalStats.mudah }} kartu</span>
                <span class="font-extrabold text-slate-800 text-xs sm:text-sm md:text-base text-right min-w-[34px]">{{ getStatPercent(totalStats.mudah, totalStats.worked || totalStats.total) }}%</span>
              </div>

              <!-- Baik -->
              <div class="grid grid-cols-[auto_1fr_auto] items-center gap-2 sm:gap-3">
                <div class="flex items-center gap-2.5">
                  <span class="w-3.5 h-3.5 rounded-[5px] bg-[#22C55E] flex-shrink-0"></span>
                  <span class="font-medium text-slate-800 text-xs sm:text-sm">Baik</span>
                </div>
                <span class="text-slate-400 text-xs font-normal text-right pr-2 whitespace-nowrap">{{ totalStats.baik }} kartu</span>
                <span class="font-extrabold text-slate-800 text-xs sm:text-sm md:text-base text-right min-w-[34px]">{{ getStatPercent(totalStats.baik, totalStats.worked || totalStats.total) }}%</span>
              </div>

              <!-- Sulit -->
              <div class="grid grid-cols-[auto_1fr_auto] items-center gap-2 sm:gap-3">
                <div class="flex items-center gap-2.5">
                  <span class="w-3.5 h-3.5 rounded-[5px] bg-[#EAB308] flex-shrink-0"></span>
                  <span class="font-medium text-slate-800 text-xs sm:text-sm">Sulit</span>
                </div>
                <span class="text-slate-400 text-xs font-normal text-right pr-2 whitespace-nowrap">{{ totalStats.sulit }} kartu</span>
                <span class="font-extrabold text-slate-800 text-xs sm:text-sm md:text-base text-right min-w-[34px]">{{ getStatPercent(totalStats.sulit, totalStats.worked || totalStats.total) }}%</span>
              </div>

              <!-- Ulangi -->
              <div class="grid grid-cols-[auto_1fr_auto] items-center gap-2 sm:gap-3">
                <div class="flex items-center gap-2.5">
                  <span class="w-3.5 h-3.5 rounded-[5px] bg-[#EF4444] flex-shrink-0"></span>
                  <span class="font-medium text-slate-800 text-xs sm:text-sm">Ulangi</span>
                </div>
                <span class="text-slate-400 text-xs font-normal text-right pr-2 whitespace-nowrap">{{ totalStats.ulang }} kartu</span>
                <span class="font-extrabold text-slate-800 text-xs sm:text-sm md:text-base text-right min-w-[34px]">{{ getStatPercent(totalStats.ulang, totalStats.worked || totalStats.total) }}%</span>
              </div>

            </div>
          </div>
        </div>

        <!-- Right: Progres per Topik (span 7 on xl) -->
        <div class="xl:col-span-7 bg-white border border-slate-100 rounded-2xl md:rounded-3xl p-6 shadow-sm flex flex-col justify-between">
          <div>
            <div class="flex items-center gap-3 mb-6">
              <svg class="w-6 h-6 text-[#4C85EC] flex-shrink-0" viewBox="0 0 24 24" fill="currentColor">
                <rect x="3" y="3" width="7.5" height="7.5" rx="2" />
                <rect x="13.5" y="3" width="7.5" height="7.5" rx="2" />
                <rect x="3" y="13.5" width="7.5" height="7.5" rx="2" />
                <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="2" />
              </svg>
              <h3 class="text-lg md:text-xl font-bold text-slate-800 m-0">Progres per Topik</h3>
            </div>

            <!-- List of Topic Progresses -->
            <div class="space-y-4 max-h-[185px] overflow-y-auto pr-1 scrollbar-thin">
              <ng-container *ngIf="categoriesWithProgress.length > 0; else noTopicProgress">
                <div *ngFor="let cat of (showAllTopicsProgress ? categoriesWithProgress : categoriesWithProgress.slice(0, 3))" class="space-y-1.5">
                  <div class="flex items-center justify-between text-sm">
                    <span class="font-normal text-slate-700 text-sm truncate max-w-[220px]" [title]="cat.name">{{ formatTopicName(cat.name) }}</span>
                    <span class="text-slate-400 text-xs font-normal flex items-center gap-1.5">
                      <i class="pi pi-copy text-[11px] text-slate-400"></i>
                      {{ categoryCounts[cat.id!] || 0 }} Kartu
                    </span>
                  </div>
                  
                  <!-- Stacked Progress bar -->
                  <div class="w-full h-1.5 bg-[#F1F5F9] rounded-full overflow-hidden flex">
                    <div class="h-full bg-[#29A6E8] transition-all duration-500" [style.width.%]="(categoryStats[cat.id!].mudah / categoryStats[cat.id!].worked) * 100" *ngIf="categoryStats[cat.id!].mudah > 0"></div>
                    <div class="h-full bg-[#22C55E] transition-all duration-500" [style.width.%]="(categoryStats[cat.id!].baik / categoryStats[cat.id!].worked) * 100" *ngIf="categoryStats[cat.id!].baik > 0"></div>
                    <div class="h-full bg-[#EAB308] transition-all duration-500" [style.width.%]="(categoryStats[cat.id!].sulit / categoryStats[cat.id!].worked) * 100" *ngIf="categoryStats[cat.id!].sulit > 0"></div>
                    <div class="h-full bg-[#EF4444] transition-all duration-500" [style.width.%]="(categoryStats[cat.id!].ulang / categoryStats[cat.id!].worked) * 100" *ngIf="categoryStats[cat.id!].ulang > 0"></div>
                  </div>
                </div>
              </ng-container>

              <ng-template #noTopicProgress>
                <div class="text-sm text-slate-400 italic py-6 text-center">
                  Belum ada progres materi yang dikerjakan.
                </div>
              </ng-template>
            </div>
          </div>

          <!-- Bottom Expand Toggle -->
          <div class="mt-4 pt-2 text-center" *ngIf="categoriesWithProgress.length > 3">
            <button 
              (click)="showAllTopicsProgress = !showAllTopicsProgress"
              class="text-xs sm:text-sm font-semibold text-[#4C85EC] hover:text-blue-700 bg-transparent border-none cursor-pointer transition-colors">
              {{ showAllTopicsProgress ? 'Sembunyikan' : 'Tampilkan Semua' }}
            </button>
          </div>
        </div>

      </div>

      <!-- Section Title & Search Row ("Pilih Materi") -->
      <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pt-2">
        <h3 class="text-lg font-bold text-slate-900 m-0">Pilih Materi</h3>
        
        <div class="relative w-full sm:w-72">
          <span class="absolute inset-y-0 left-0 flex items-center pl-3.5 pointer-events-none text-slate-400">
            <i class="pi pi-search text-xs"></i>
          </span>
          <input
            type="text"
            [(ngModel)]="categorySearchQuery"
            (ngModelChange)="categoryFirst = 0"
            class="w-full pl-9 pr-4 py-2 bg-white border border-slate-200 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500/20 text-xs text-slate-800 placeholder-slate-400 transition-all shadow-xs"
            placeholder="Cari Topik atau Kata Kunci" />
        </div>
      </div>

      <!-- Skeleton Loader -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 animate-pulse" *ngIf="loading && !selectedCategory">
        <div *ngFor="let i of [1,2,3,4,5,6]" class="bg-white rounded-2xl border border-slate-200 p-6 h-48 flex flex-col justify-between">
          <div>
            <div class="flex justify-between items-start mb-4">
              <div class="w-10 h-10 bg-slate-200 rounded-xl"></div>
              <div class="w-20 h-5 bg-slate-200 rounded-full"></div>
            </div>
            <div class="w-3/4 h-5 bg-slate-100 rounded mb-3"></div>
            <div class="w-full h-3 bg-slate-100 rounded mb-2"></div>
          </div>
          <div class="w-24 h-4 bg-slate-100 rounded mt-4"></div>
        </div>
      </div>

      <!-- Grid of Cards (Custom Session Card FIRST, then Category Cards) -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" *ngIf="!loading">
        
        <!-- 1. Custom Session Card (Always Shown on Every Page) -->
        <div 
          (click)="openCustomSessionDialog($event)"
          class="bg-gradient-to-br from-[#4A85ED] to-[#3B82F6] text-white rounded-2xl p-6 shadow-sm hover:shadow-md hover:scale-[1.01] transition-all cursor-pointer flex flex-col justify-between h-full group">
          <div>
            <div class="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center mb-4 text-white group-hover:scale-110 transition-transform">
              <i class="pi pi-sliders-h text-lg"></i>
            </div>
            <h4 class="text-base font-bold text-white mb-1.5 m-0">Custom Session</h4>
            <p class="text-sm text-blue-50/90 leading-relaxed mb-6">
              Pilih beberapa topik tertentu dan atur tingkat kesulitan sesukamu
            </p>
          </div>
          <div>
            <button 
              type="button"
              (click)="openCustomSessionDialog($event)"
              class="px-4 py-2 bg-white hover:bg-blue-50 text-[#3B82F6] font-bold rounded-xl border-none transition-all active:scale-95 text-xs shadow-xs cursor-pointer">
              Pilih Topik
            </button>
          </div>
        </div>

        <!-- 2. Topic / Category Cards -->
        <ng-container *ngIf="filteredCategories.length > 0">
          <div 
            *ngFor="let cat of paginatedCategories" 
            (click)="selectCategoryCard(cat)"
            class="bg-white rounded-2xl border border-slate-100 p-6 hover:shadow-md hover:border-blue-300 transition-all duration-300 cursor-pointer flex flex-col justify-between group h-full">
            <div>
              <div class="flex justify-between items-start mb-3">
                <!-- Icon Badge (No Emoji! Uses Puzzle Icon) -->
                <div class="w-10 h-10 bg-blue-50 text-[#3B82F6] group-hover:bg-[#3B82F6] group-hover:text-white rounded-xl flex items-center justify-center text-base transition-colors duration-300">
                  <i class="pi pi-box"></i>
                </div>
                <span class="inline-flex items-center gap-1 text-slate-400 text-sm font-medium">
                  <i class="pi pi-copy text-[13px]"></i>
                  {{ categoryCounts[cat.id!] !== undefined ? categoryCounts[cat.id!] + ' Kartu' : '...' }}
                </span>
              </div>
              
              <h4 class="text-base font-bold text-slate-900 mb-1 group-hover:text-[#3B82F6] transition-colors duration-300 m-0">
                {{ cat.name }}
              </h4>
              <p class="text-sm text-slate-500 line-clamp-2 mb-4 leading-relaxed">
                {{ cat.description || 'Belum ada deskripsi' }}
              </p>

              <!-- Progress bar per topic -->
              <div class="mt-3 pt-3 border-t border-slate-100">
                <div class="w-full h-1.5 bg-slate-100 rounded-full overflow-hidden flex mb-2">
                  <ng-container *ngIf="categoryStats[cat.id!] && categoryStats[cat.id!].worked > 0; else emptyCategoryProgress">
                    <div class="h-full bg-[#38BDF8]" [style.width.%]="(categoryStats[cat.id!].mudah / categoryStats[cat.id!].worked) * 100" *ngIf="categoryStats[cat.id!].mudah > 0"></div>
                    <div class="h-full bg-[#22C55E]" [style.width.%]="(categoryStats[cat.id!].baik / categoryStats[cat.id!].worked) * 100" *ngIf="categoryStats[cat.id!].baik > 0"></div>
                    <div class="h-full bg-[#EAB308]" [style.width.%]="(categoryStats[cat.id!].sulit / categoryStats[cat.id!].worked) * 100" *ngIf="categoryStats[cat.id!].sulit > 0"></div>
                    <div class="h-full bg-[#EF4444]" [style.width.%]="(categoryStats[cat.id!].ulang / categoryStats[cat.id!].worked) * 100" *ngIf="categoryStats[cat.id!].ulang > 0"></div>
                  </ng-container>
                  <ng-template #emptyCategoryProgress>
                    <div class="h-full w-full bg-slate-200"></div>
                  </ng-template>
                </div>

                <div class="flex items-center justify-between text-[13px] text-slate-400">
                  <span>
                    {{ (categoryStats[cat.id!]?.worked || 0) }}/{{ (categoryStats[cat.id!]?.total || categoryCounts[cat.id!] || 0) }} topik telah dikerjakan
                  </span>
                  <span class="text-[#3B82F6] font-semibold flex items-center gap-1 group-hover:translate-x-0.5 transition-transform">
                    Lanjutkan <i class="pi pi-arrow-right text-[11px]"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

      </div>

      <!-- Pagination for Topic Cards -->
      <div *ngIf="!loading && filteredCategories.length > categoryRows" class="flex justify-center mt-6">
        <p-paginator
          [first]="categoryFirst"
          [rows]="categoryRows"
          [totalRecords]="filteredCategories.length"
          [rowsPerPageOptions]="[10, 20, 30, 50]"
          (onPageChange)="onCategoryPageChange($event)">
        </p-paginator>
      </div>

      <!-- Empty State for search -->
      <div class="text-center bg-white py-12 px-8 rounded-2xl border border-slate-100 shadow-xs" *ngIf="!loading && filteredCategories.length === 0">
        <i class="pi pi-filter-slash text-3xl text-slate-300 mb-3"></i>
        <h4 class="text-sm font-semibold text-slate-800 mb-1">Materi Tidak Ditemukan</h4>
        <p class="text-slate-400 text-xs m-0">Tidak ada topik yang cocok dengan pencarian "{{ categorySearchQuery }}"</p>
      </div>

    </div>


    <!-- Flashcard Display Skeleton Loader -->
    <div class="w-full px-4" *ngIf="selectedCategory && loading">
      <div class="w-full bg-white rounded-3xl border border-[#E2E8F0] p-6 md:p-8 flex flex-col gap-6 mb-6 shadow-sm animate-pulse">
        <!-- Top Bar -->
        <div class="flex items-center justify-between pb-4 border-b border-[#F1F5F9] w-full">
          <div class="flex items-center gap-3">
            <div class="w-12 h-12 bg-gray-200 rounded-xl"></div>
            <div class="flex flex-col gap-2">
              <div class="w-32 h-5 bg-[#F1F5F9] rounded"></div>
              <div class="w-16 h-3 bg-[#F1F5F9] rounded"></div>
            </div>
          </div>
          <div class="flex gap-2">
            <div class="w-10 h-10 bg-[#F1F5F9] rounded-xl"></div>
            <div class="w-10 h-10 bg-[#F1F5F9] rounded-xl"></div>
          </div>
        </div>
        <!-- Card Body -->
        <div class="w-full my-12 flex flex-col items-center gap-4">
          <div class="w-3/4 h-8 bg-[#F1F5F9] rounded-full"></div>
          <div class="w-1/2 h-8 bg-[#F1F5F9] rounded-full"></div>
          <div class="w-16 h-1 bg-[#F1F5F9] rounded mt-2"></div>
        </div>
        <!-- Input box placeholder -->
        <div class="flex flex-col gap-2 w-full mt-4">
          <div class="w-20 h-4 bg-[#F1F5F9] rounded"></div>
          <div class="w-full h-24 bg-[#F1F5F9] rounded-2xl"></div>
        </div>
        <!-- Button placeholder -->
        <div class="w-full h-12 bg-[#F1F5F9] rounded-2xl mt-2"></div>
      </div>
    </div>

    <!-- Flashcard Display -->
    <!-- Flashcard Display / Configuration (Matching Figma exactly) -->
    <div [class]="isFullscreen ? 'w-full p-0 min-h-screen' : 'w-full px-0 sm:px-2 md:px-4 py-2 sm:py-4'" *ngIf="selectedCategory && !loading && allFlashcards.length > 0">
      
      <!-- Unified Single Card Container (Fixed 483px height matching Figma 925x483) -->
      <div [class]="isFullscreen 
        ? 'w-full bg-white rounded-none border-none shadow-none overflow-hidden p-0 min-h-screen flex flex-col' 
        : 'w-full h-[483px] min-h-[483px] max-h-[483px] bg-white rounded-2xl sm:rounded-3xl border border-slate-100/80 mb-6 shadow-sm overflow-hidden p-0 flex flex-col justify-between'">
        
        <!-- Top Hero Banner Header for Topic (Matching Figma Images 1 & 2) -->
        <div class="w-full bg-gradient-to-r from-[#3B82F6] via-[#2F8EF7] to-[#06B6D4] text-white px-6 py-3 sm:px-8 sm:py-3.5 flex items-center justify-between relative shrink-0">
          
          <div class="z-10 flex flex-col items-start">
            <h2 class="text-lg sm:text-xl font-bold text-white m-0 tracking-tight leading-tight">
              {{ selectedCategory.name }}
            </h2>
            
            <div class="mt-1">
              <span class="inline-flex items-center gap-1.5 bg-white/20 backdrop-blur-xs text-white px-2.5 py-0.5 rounded-full text-[11px] font-semibold">
                <i class="pi pi-clone text-[10px]"></i>
                {{ allFlashcards.length }} Kartu
              </span>
            </div>
          </div>

          <!-- Right Action Controls (Fullscreen & Close) -->
          <div class="flex items-center gap-2 sm:gap-2.5 z-10 flex-shrink-0">
            <button 
              type="button"
              (click)="toggleFullscreen()"
              class="w-8 h-8 sm:w-9 sm:h-9 rounded-xl bg-white text-[#0EA5E9] hover:bg-white/90 flex items-center justify-center border-none shadow-xs transition-all active:scale-95 cursor-pointer"
              [title]="isFullscreen ? 'Minimize' : 'Fullscreen'">
              <i class="pi" [ngClass]="isFullscreen ? 'pi-window-minimize' : 'pi-expand'" style="font-size: 13px;"></i>
            </button>

            <button 
              type="button"
              (click)="changeCategory()"
              class="w-8 h-8 sm:w-9 sm:h-9 rounded-xl bg-white text-[#0EA5E9] hover:bg-white/90 flex items-center justify-center border-none shadow-xs transition-all active:scale-95 cursor-pointer"
              title="Tutup">
              <i class="pi pi-times" style="font-size: 13px;"></i>
            </button>
          </div>
        </div>

        <!-- 2. Session Configuration Screen (Shown when isConfiguringSession is true) -->
        <div *ngIf="isConfiguringSession" class="p-4 sm:p-6 flex flex-col justify-between gap-4 w-full flex-1 min-h-0 overflow-y-auto select-none">
          
          <!-- Section 1: Pilih Jenis Pertanyaan -->
          <div class="w-full flex flex-col gap-3">
            <h3 class="text-sm md:text-base font-bold text-slate-800 m-0">Pilih Jenis Pertanyaan</h3>
            
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 w-full">
              
              <!-- Belum Pernah -->
              <div 
                (click)="changeSessionType('new')"
                [class]="sessionType === 'new' 
                  ? 'flex flex-col items-center justify-center p-6 bg-[#EFF6FF] border-2 border-[#3B82F6] rounded-2xl transition-all cursor-pointer shadow-xs'
                  : 'flex flex-col items-center justify-center p-6 bg-white border border-slate-200 hover:border-slate-300 rounded-2xl transition-all cursor-pointer'">
                <div class="w-11 h-11 rounded-xl bg-[#DBEAFE] text-[#2563EB] font-extrabold text-[11px] flex items-center justify-center mb-3">
                  NEW
                </div>
                <h4 [class]="sessionType === 'new' ? 'font-bold text-[#2563EB] text-sm mb-1 m-0' : 'font-bold text-slate-900 text-sm mb-1 m-0'">Belum Pernah</h4>
                <p class="text-xs text-slate-400 text-center m-0 leading-relaxed">
                  Fokus pada kartu baru yang belum dipelajari sama sekali.
                </p>
              </div>

              <!-- Campur -->
              <div 
                (click)="changeSessionType('worked')"
                [class]="sessionType === 'worked' 
                  ? 'flex flex-col items-center justify-center p-6 bg-[#EFF6FF] border-2 border-[#3B82F6] rounded-2xl transition-all cursor-pointer shadow-xs'
                  : 'flex flex-col items-center justify-center p-6 bg-white border border-slate-200 hover:border-slate-300 rounded-2xl transition-all cursor-pointer'">
                <div class="w-11 h-11 rounded-xl bg-[#DBEAFE] text-[#2563EB] flex items-center justify-center mb-3 text-base">
                  <i class="pi pi-sync"></i>
                </div>
                <h4 [class]="sessionType === 'worked' ? 'font-bold text-[#2563EB] text-sm mb-1 m-0' : 'font-bold text-slate-900 text-sm mb-1 m-0'">Campur</h4>
                <p class="text-xs text-slate-400 text-center m-0 leading-relaxed">
                  Kombinasi antara kartu baru dan pengulangan kartu lama.
                </p>
              </div>

              <!-- Semua -->
              <div 
                (click)="changeSessionType('all')"
                [class]="sessionType === 'all' 
                  ? 'flex flex-col items-center justify-center p-6 bg-[#EFF6FF] border-2 border-[#3B82F6] rounded-2xl transition-all cursor-pointer shadow-xs'
                  : 'flex flex-col items-center justify-center p-6 bg-white border border-slate-200 hover:border-slate-300 rounded-2xl transition-all cursor-pointer'">
                <div class="w-11 h-11 rounded-xl bg-[#DBEAFE] text-[#2563EB] flex items-center justify-center mb-3 text-base">
                  <i class="pi pi-check-square"></i>
                </div>
                <h4 [class]="sessionType === 'all' ? 'font-bold text-[#2563EB] text-sm mb-1 m-0' : 'font-bold text-slate-900 text-sm mb-1 m-0'">Semua</h4>
                <p class="text-xs text-slate-400 text-center m-0 leading-relaxed">
                  Pelajari seluruh dek tanpa batas kategori tertentu.
                </p>
              </div>

            </div>
          </div>

          <!-- Section 2: Batas Kartu Sesi -->
          <div class="w-full flex flex-col gap-3">
            <h3 class="text-sm md:text-base font-bold text-slate-800 m-0">Jumlah Kartu Sesi Ini</h3>
            
            <div class="flex flex-wrap gap-2.5">
              <button 
                *ngFor="let limit of getAvailableSessionLimits()" 
                type="button"
                (click)="sessionLimit = limit"
                [class]="sessionLimit === limit 
                  ? 'px-4 py-2 bg-[#3B82F6] text-white rounded-xl text-xs font-bold transition-all shadow-xs cursor-pointer border-none'
                  : 'px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-xl text-xs font-semibold transition-all cursor-pointer border-none'">
                {{ limit === 'all' ? 'Semua Kartu' : limit + ' Kartu' }}
              </button>
            </div>
          </div>

          <!-- Section 3: Action Button -->
          <div class="w-full flex justify-end pt-4">
            <button 
              type="button"
              (click)="startSession()"
              class="px-6 py-3 bg-[#3B82F6] hover:bg-blue-600 text-white rounded-xl text-sm font-bold transition-all shadow-sm cursor-pointer border-none flex items-center gap-2">
              <span>Mulai Belajar</span>
              <i class="pi pi-arrow-right text-xs"></i>
            </button>
          </div>

        </div>

        <!-- 3. Study Session (Shown when isConfiguringSession is false - Matching Figma Images 1 & 2) -->
        <div *ngIf="!isConfiguringSession" class="p-3.5 sm:p-4 md:p-5 flex flex-col justify-between gap-2.5 sm:gap-3 w-full flex-1 min-h-0 select-none">
          
          <!-- Main Flashcard Box (Question / Answer - Flex 1 inside 483px container) -->
          <div 
            (click)="isFlipped ? null : flipToAnswer()"
            [class]="isFlipped 
              ? 'w-full flex-1 min-h-0 bg-[#4880F5] text-white rounded-2xl sm:rounded-3xl pt-8 pb-2.5 px-4 sm:pt-9 sm:pb-2.5 sm:px-6 flex flex-col items-center justify-between relative text-center shadow-xs transition-all duration-300 overflow-hidden select-none card-flipped-active' 
              : 'w-full flex-1 min-h-0 bg-[#EEF4FF] rounded-2xl sm:rounded-3xl pt-8 pb-2.5 px-4 sm:pt-9 sm:pb-2.5 sm:px-6 flex flex-col items-center justify-between relative text-center cursor-pointer transition-all duration-300 shadow-xs overflow-hidden select-none'">
            
            <!-- Badges Top Left -->
            <div class="absolute top-2.5 left-3 sm:top-3 sm:left-4 flex items-center gap-2 z-10">
              <!-- Index Badge (e.g. 1/10) -->
              <span [class]="isFlipped ? 'bg-white text-[#4880F5] px-2.5 py-0.5 rounded-full text-xs font-bold shadow-xs' : 'bg-white text-[#3B82F6] px-2.5 py-0.5 rounded-full text-xs font-bold shadow-xs'">
                {{ currentIndex + 1 }}/{{ filteredFlashcards.length }}
              </span>
              
              <!-- Jawaban Badge (Shown when flipped) -->
              <span *ngIf="isFlipped" class="bg-white text-[#4880F5] px-2.5 py-0.5 rounded-full text-xs font-bold shadow-xs">
                Jawaban
              </span>
            </div>

            <!-- Flashcard Center Content (Fixed container, stationary text, only image scrolls if present) -->
            <div 
              #cardContentContainer
              class="w-full flex-1 min-h-0 flex flex-col items-center justify-center py-2 sm:py-3 px-3 sm:px-6"
              [class.overflow-y-auto]="!hasActiveImages"
              [class.overflow-hidden]="hasActiveImages"
              [class.card-scroll-dynamic]="!hasActiveImages"
              [class.is-scrolling]="!hasActiveImages && isCardScrolling"
              (scroll)="!hasActiveImages ? onCardScroll() : null"
              (wheel)="onCardWheel($event)"
              (click)="$event.stopPropagation()">
              
              <div class="my-auto w-full flex flex-col items-center flex-1 min-h-0 justify-center">
                
                <!-- ================= OCCLUSION CARD ================= -->
                <ng-container *ngIf="isOcclusionCard; else standardCardBlock">
                  <div [class]="(!isFlipped && currentFlashcard?.text) 
                    ? 'w-full flex-1 min-h-0 flex flex-col md:flex-row gap-6 items-center justify-between card-side-by-side overflow-hidden my-auto' 
                    : 'w-full flex-1 min-h-0 flex flex-col items-center justify-center overflow-hidden my-auto'">
                    
                    <!-- Left: Prompt / Text (Only shown on Question side if text exists) -->
                    <div class="flex-1 min-w-0 w-full text-left my-auto" *ngIf="!isFlipped && currentFlashcard?.text">
                      <div class="flashcard-text-container flashcard-question-text text-[#1E293B] font-bold leading-snug break-normal"
                           [innerHTML]="getFormattedQuestion()">
                      </div>
                    </div>

                    <!-- Right / Center: Occlusion Image with overlays (Centered & Full Width when isFlipped or no text) -->
                    <div 
                      #imageScrollContainer
                      class="flex flex-col items-center justify-start max-w-full overflow-y-auto card-scroll-dynamic pr-1"
                      [class.max-h-[320px]]="!isFlipped && currentFlashcard?.text"
                      [class.md:max-h-[360px]]="!isFlipped && currentFlashcard?.text"
                      [class.max-h-[380px]]="isFlipped || !currentFlashcard?.text"
                      [class.md:max-h-[420px]]="isFlipped || !currentFlashcard?.text"
                      [class.is-scrolling]="isCardScrolling"
                      (scroll)="onCardScroll()"
                      [class.shrink-0]="!isFlipped && currentFlashcard?.text"
                      [class.md:max-w-[55%]]="!isFlipped && currentFlashcard?.text"
                      [class.w-full]="isFlipped || !currentFlashcard?.text">
                      <div class="relative overflow-visible mx-auto max-w-full flex flex-col items-center justify-start select-none pt-2 pb-3" style="width: fit-content;">
                        <img 
                          [src]="getImageUrl(questionImages[0] || currentFlashcard?.question_image_path || answerImages[0] || currentFlashcard?.image_path || '')" 
                          class="block max-w-full h-auto w-auto rounded-xl object-contain cursor-zoom-in border-0 shadow-none flashcard-main-image" 
                          (click)="viewImage(getImageUrl(questionImages[0] || currentFlashcard?.question_image_path || answerImages[0] || currentFlashcard?.image_path || '')); $event.stopPropagation()" />
                        
                        <!-- Occlusion Overlays -->
                        <div *ngFor="let rect of occlusions; let idx = index"
                             (click)="revealOcclusion(idx, $event)"
                             [style.left.%]="rect.x"
                             [style.top.%]="rect.y"
                             [style.width.%]="(isFlipped || revealedOcclusions[idx]) ? null : rect.w"
                             [style.min-width.%]="rect.w"
                             [style.height.%]="(isFlipped || revealedOcclusions[idx]) ? null : rect.h"
                             [style.min-height.%]="rect.h"
                             [style.max-width]="'92%'"
                             [class]="(isFlipped || revealedOcclusions[idx]) 
                               ? 'absolute bg-[#4880F5] text-white border-2 border-white/90 flex items-center justify-center font-bold text-xs md:text-sm rounded-xl shadow-lg px-2.5 py-1.5 whitespace-nowrap select-none w-max z-20 transition-all cursor-pointer'
                               : 'absolute bg-[#4880F5] border border-white/80 flex items-center justify-center text-white font-extrabold text-xs rounded-xl shadow-xs cursor-pointer select-none z-20 transition-all'">
                          <span>{{ (isFlipped || revealedOcclusions[idx]) ? (rect.label || 'Area ' + (idx + 1)) : '...' }}</span>
                        </div>
                      </div>
                    </div>

                  </div>
                </ng-container>

                <!-- ================= STANDARD (TEXT / CLOZE) CARD ================= -->
                <ng-template #standardCardBlock>
                  
                  <!-- --- QUESTION SIDE (!isFlipped) --- -->
                  <ng-container *ngIf="!isFlipped">
                    
                    <!-- If Question has Image: 2-column side-by-side (Text Left, Image Right) -->
                    <div class="w-full flex-1 min-h-0 flex flex-col md:flex-row gap-6 md:gap-8 items-center justify-between card-side-by-side overflow-hidden my-auto" *ngIf="hasQuestionImages; else questionTextOnly">
                      
                      <!-- Left Column: Question Text (Stationary, never scrolls) -->
                      <div class="flex-1 min-w-0 w-full text-left my-auto">
                        <div class="flashcard-text-container flashcard-question-text text-[#1E293B] font-bold leading-snug break-normal" 
                             [innerHTML]="getFormattedQuestion()">
                        </div>
                      </div>

                      <!-- Right Column: Question Image Section (Only this scrolls) -->
                      <div class="shrink-0 flex items-center justify-center gap-2.5 max-w-full md:max-w-[48%] lg:max-w-[50%]" (click)="$event.stopPropagation()">
                        <!-- Scrollable image wrapper without border and without shadow -->
                        <div 
                          #imageScrollContainer
                          class="max-h-[300px] md:max-h-[320px] overflow-y-auto card-scroll-dynamic flex flex-col items-center justify-start pr-1"
                          [class.is-scrolling]="isCardScrolling"
                          (scroll)="onCardScroll()">
                          <img 
                            [src]="getImageUrl(questionImages[activeQuestionImgIndex || 0])" 
                            alt="Gambar Pertanyaan"
                            class="block max-w-full h-auto w-auto rounded-xl object-contain cursor-zoom-in hover:scale-[1.01] transition-transform border-0 shadow-none flashcard-main-image" 
                            (click)="viewImage(getImageUrl(questionImages[activeQuestionImgIndex || 0]))" />
                        </div>

                        <!-- Thumbnail Sidebar (if > 1 images) with inside right scrollbar -->
                        <div class="thumb-sidebar thumb-sidebar-question scrollbar-thin shrink-0" *ngIf="questionImages.length > 1">
                          <div *ngFor="let img of questionImages; let idx = index"
                               (click)="selectQuestionImage(idx, $event)"
                               class="thumb-item"
                               [class.active]="activeQuestionImgIndex === idx">
                            <img [src]="getImageUrl(img)" class="w-full h-full object-cover" />
                          </div>
                        </div>
                      </div>

                    </div>

                    <!-- If Question has NO Image: Centered Text -->
                    <ng-template #questionTextOnly>
                      <div class="w-full max-w-4xl mx-auto px-4 py-2">
                        <div class="flashcard-text-container flashcard-question-text text-[#1E293B] font-bold text-center leading-snug break-normal" 
                             [innerHTML]="getFormattedQuestion()">
                        </div>
                      </div>
                    </ng-template>

                  </ng-container>

                  <!-- --- ANSWER SIDE (isFlipped) --- -->
                  <ng-container *ngIf="isFlipped">
                    
                    <!-- If Answer has Image: 2-column side-by-side (Text Left, Image Right) OR centered if no text -->
                    <div [class]="getFormattedAnswer() 
                      ? 'w-full flex-1 min-h-0 flex flex-col md:flex-row gap-6 md:gap-8 items-center justify-between card-side-by-side overflow-hidden my-auto' 
                      : 'w-full flex-1 min-h-0 flex flex-col items-center justify-center overflow-hidden my-auto'" 
                      *ngIf="hasAnswerImages; else answerTextOnly">
                      
                      <!-- Left Column: Answer Text (Stationary, never scrolls) -->
                      <div class="flex-1 min-w-0 w-full text-left my-auto" *ngIf="getFormattedAnswer()">
                        <div class="flashcard-text-container flashcard-answer-text text-white font-medium leading-relaxed break-normal" 
                             [innerHTML]="getFormattedAnswer()">
                        </div>
                      </div>

                      <!-- Right Column: Answer Image Section (Only this scrolls) -->
                      <div class="flex items-center justify-center gap-2.5 max-w-full" 
                           [class.shrink-0]="getFormattedAnswer()"
                           [class.md:max-w-[48%]]="getFormattedAnswer()" 
                           [class.lg:max-w-[50%]]="getFormattedAnswer()"
                           [class.w-full]="!getFormattedAnswer()"
                           (click)="$event.stopPropagation()">
                        <!-- Scrollable image wrapper without border and without shadow -->
                        <div 
                          #imageScrollContainer
                          class="max-h-[300px] md:max-h-[320px] overflow-y-auto card-scroll-dynamic flex flex-col items-center justify-start pr-1"
                          [class.is-scrolling]="isCardScrolling"
                          (scroll)="onCardScroll()">
                          <img 
                            [src]="getImageUrl(answerImages[activeAnswerImgIndex || 0])" 
                            alt="Gambar Jawaban"
                            class="block max-w-full h-auto w-auto rounded-xl object-contain cursor-zoom-in hover:scale-[1.01] transition-transform border-0 shadow-none flashcard-main-image" 
                            (click)="viewImage(getImageUrl(answerImages[activeAnswerImgIndex || 0]))" />
                        </div>

                        <!-- Thumbnail Sidebar (if > 1 images) with inside right scrollbar -->
                        <div class="thumb-sidebar scrollbar-thin shrink-0" *ngIf="answerImages.length > 1">
                          <div *ngFor="let img of answerImages; let idx = index"
                               (click)="selectAnswerImage(idx, $event)"
                               class="thumb-item"
                               [class.active]="activeAnswerImgIndex === idx">
                            <ng-container *ngIf="img.toLowerCase().endsWith('.pdf'); else thumbImg">
                              <div class="w-full h-full flex items-center justify-center bg-white/20">
                                <i class="pi pi-file-pdf text-red-400 text-lg"></i>
                              </div>
                            </ng-container>
                            <ng-template #thumbImg>
                              <img [src]="getImageUrl(img)" class="w-full h-full object-cover" />
                            </ng-template>
                          </div>
                        </div>
                      </div>

                    </div>

                    <!-- If Answer has NO Image: Centered Text -->
                    <ng-template #answerTextOnly>
                      <div class="w-full max-w-4xl mx-auto flex flex-col items-center gap-3 py-2">
                        <div class="flashcard-text-container flashcard-answer-text text-white font-medium text-center leading-relaxed break-normal" 
                             [innerHTML]="getFormattedAnswer()">
                        </div>
                      </div>
                    </ng-template>

                  </ng-container>

                </ng-template>
              </div>

            </div>

            <!-- Bottom Action Prompt Text (Matching Figma Image 2) -->
            <div class="pt-1 pb-0.5 z-10 shrink-0">
              <span 
                *ngIf="!isFlipped" 
                (click)="flipToAnswer(); $event.stopPropagation()"
                class="text-xs sm:text-[13px] text-[#4C85EC] hover:text-blue-700 font-medium cursor-pointer transition-colors">
                Klik untuk melihat jawaban
              </span>

              <span 
                *ngIf="isFlipped" 
                (click)="flipToQuestion(); $event.stopPropagation()" 
                class="text-xs sm:text-[13px] text-white/90 hover:text-white font-medium cursor-pointer transition-colors">
                Klik untuk kembali ke soal
              </span>
            </div>

          </div>

          <!-- 3. Bottom Controls Row (Compact & Fully Horizontal) -->
          <div class="flex items-center justify-between gap-1 sm:gap-3 md:gap-4 w-full shrink-0 flex-nowrap">
            
            <!-- Sebelumnya Button -->
            <button 
              type="button"
              (click)="previousCard($event)" 
              [disabled]="currentIndex === 0" 
              class="px-2.5 sm:px-4 md:px-5 py-2 sm:py-2.5 md:py-3 rounded-xl sm:rounded-2xl bg-[#4880F5] hover:bg-blue-600 text-white text-[11px] sm:text-xs md:text-sm font-semibold flex items-center justify-center gap-1 sm:gap-1.5 cursor-pointer border-none shadow-xs transition-all active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed shrink-0">
              <i class="pi pi-chevron-left text-[10px] sm:text-[11px]"></i>
              <span class="hidden sm:inline">Sebelumnya</span>
            </button>

            <!-- 4 Rating Cards (Ulangi, Sulit, Baik, Mudah - Always Horizontal in a Single Row) -->
            <div class="flex items-center justify-center gap-1 sm:gap-2 md:gap-3 flex-nowrap shrink-0">
              
              <!-- Ulangi Button -->
              <button 
                type="button"
                (click)="selectRating('Ulangi')"
                [class]="selectedRating === 'Ulangi' 
                  ? 'flex flex-col items-center justify-center w-[52px] sm:w-[68px] md:w-[78px] h-[52px] sm:h-[64px] md:h-[72px] p-1 sm:p-1.5 bg-[#FEE2E2] border-2 border-[#EF4444] rounded-xl sm:rounded-2xl transition-all cursor-pointer shadow-xs active:scale-95'
                  : 'flex flex-col items-center justify-center w-[52px] sm:w-[68px] md:w-[78px] h-[52px] sm:h-[64px] md:h-[72px] p-1 sm:p-1.5 bg-[#FEE2E2]/70 hover:bg-[#FEE2E2] border-2 border-transparent rounded-xl sm:rounded-2xl transition-all cursor-pointer active:scale-95'">
                <span class="text-base sm:text-xl md:text-2xl leading-none">😭</span>
                <span class="text-[9px] sm:text-[11px] md:text-xs font-bold text-[#DC2626] mt-0.5 sm:mt-1">Ulangi</span>
                <span class="text-[7.5px] sm:text-[9px] md:text-[10px] text-[#DC2626]/80 font-medium whitespace-nowrap">&lt;10 mnt</span>
              </button>

              <!-- Sulit Button -->
              <button 
                type="button"
                (click)="selectRating('Sulit')"
                [class]="selectedRating === 'Sulit' 
                  ? 'flex flex-col items-center justify-center w-[52px] sm:w-[68px] md:w-[78px] h-[52px] sm:h-[64px] md:h-[72px] p-1 sm:p-1.5 bg-[#FEF3C7] border-2 border-[#F59E0B] rounded-xl sm:rounded-2xl transition-all cursor-pointer shadow-xs active:scale-95'
                  : 'flex flex-col items-center justify-center w-[52px] sm:w-[68px] md:w-[78px] h-[52px] sm:h-[64px] md:h-[72px] p-1 sm:p-1.5 bg-[#FEF3C7]/70 hover:bg-[#FEF3C7] border-2 border-transparent rounded-xl sm:rounded-2xl transition-all cursor-pointer active:scale-95'">
                <span class="text-base sm:text-xl md:text-2xl leading-none">🥺</span>
                <span class="text-[9px] sm:text-[11px] md:text-xs font-bold text-[#D97706] mt-0.5 sm:mt-1">Sulit</span>
                <span class="text-[7.5px] sm:text-[9px] md:text-[10px] text-[#D97706]/80 font-medium whitespace-nowrap">&lt;1 hari</span>
              </button>

              <!-- Baik Button -->
              <button 
                type="button"
                (click)="selectRating('Baik')"
                [class]="selectedRating === 'Baik' 
                  ? 'flex flex-col items-center justify-center w-[52px] sm:w-[68px] md:w-[78px] h-[52px] sm:h-[64px] md:h-[72px] p-1 sm:p-1.5 bg-[#DCFCE7] border-2 border-[#22C55E] rounded-xl sm:rounded-2xl transition-all cursor-pointer shadow-xs active:scale-95'
                  : 'flex flex-col items-center justify-center w-[52px] sm:w-[68px] md:w-[78px] h-[52px] sm:h-[64px] md:h-[72px] p-1 sm:p-1.5 bg-[#DCFCE7]/70 hover:bg-[#DCFCE7] border-2 border-transparent rounded-xl sm:rounded-2xl transition-all cursor-pointer active:scale-95'">
                <span class="text-base sm:text-xl md:text-2xl leading-none">😊</span>
                <span class="text-[9px] sm:text-[11px] md:text-xs font-bold text-[#16A34A] mt-0.5 sm:mt-1">Baik</span>
                <span class="text-[7.5px] sm:text-[9px] md:text-[10px] text-[#16A34A]/80 font-medium whitespace-nowrap">&lt;3 hari</span>
              </button>

              <!-- Mudah Button -->
              <button 
                type="button"
                (click)="selectRating('Mudah')"
                [class]="selectedRating === 'Mudah' 
                  ? 'flex flex-col items-center justify-center w-[52px] sm:w-[68px] md:w-[78px] h-[52px] sm:h-[64px] md:h-[72px] p-1 sm:p-1.5 bg-[#E0F2FE] border-2 border-[#0284C7] rounded-xl sm:rounded-2xl transition-all cursor-pointer shadow-xs active:scale-95'
                  : 'flex flex-col items-center justify-center w-[52px] sm:w-[68px] md:w-[78px] h-[52px] sm:h-[64px] md:h-[72px] p-1 sm:p-1.5 bg-[#E0F2FE]/70 hover:bg-[#E0F2FE] border-2 border-transparent rounded-xl sm:rounded-2xl transition-all cursor-pointer active:scale-95'">
                <span class="text-base sm:text-xl md:text-2xl leading-none">😎</span>
                <span class="text-[9px] sm:text-[11px] md:text-xs font-bold text-[#0284C7] mt-0.5 sm:mt-1">Mudah</span>
                <span class="text-[7.5px] sm:text-[9px] md:text-[10px] text-[#0284C7]/80 font-medium whitespace-nowrap">&lt;10 hari</span>
              </button>

            </div>

            <!-- Selanjutnya / Selesai Button -->
            <button 
              type="button"
              (click)="nextCard($event)" 
              class="px-2.5 sm:px-4 md:px-5 py-2 sm:py-2.5 md:py-3 rounded-xl sm:rounded-2xl bg-[#4880F5] hover:bg-blue-600 text-white text-[11px] sm:text-xs md:text-sm font-semibold flex items-center justify-center gap-1 sm:gap-1.5 cursor-pointer border-none shadow-xs transition-all active:scale-95 shrink-0">
              <span class="hidden sm:inline">{{ currentIndex === filteredFlashcards.length - 1 ? 'Selesai' : 'Selanjutnya' }}</span>
              <i [class]="currentIndex === filteredFlashcards.length - 1 ? 'pi pi-check text-[10px] sm:text-[11px]' : 'pi pi-chevron-right text-[10px] sm:text-[11px]'"></i>
            </button>

          </div>
        </div>
      </div>
    </div>



    <!-- Empty -->
    <div class="text-center bg-white max-w-sm mx-auto mt-8 py-12 px-8 rounded-3xl border border-[#E2E8F0] shadow-sm" *ngIf="!loading && allFlashcards.length === 0 && selectedCategory">
      <i class="pi pi-inbox text-5xl text-[#64748B] mb-4 animate-bounce"></i>
      <h3 class="text-lg font-bold text-[#0F172A] mb-1">Belum Ada Flashcard</h3>
      <p class="text-[#64748B] text-sm mb-5">Kategori "{{ selectedCategory.name }}" belum memiliki kartu.</p>
      <button class="inline-flex items-center gap-2 px-5 py-2.5 rounded-2xl border border-[#E2E8F0] bg-white text-[#0F172A] text-sm font-semibold hover:bg-[#F8FAFC] transition-all cursor-pointer shadow-sm active:scale-95" (click)="changeCategory()">
        <i class="pi pi-arrow-left text-xs"></i> Ganti Kategori
      </button>
    </div>


    <!-- Dialog for Image/PDF Preview -->
    <p-dialog 
      [(visible)]="displayImageDialog" 
      [modal]="true" 
      [dismissableMask]="true" 
      [style]="{ 'max-width': '95vw', 'max-height': '95vh', width: 'fit-content', background: 'transparent', border: 'none', 'box-shadow': 'none' }" 
      [showHeader]="false" 
      styleClass="transparent-image-dialog"
      contentStyleClass="p-0 overflow-visible bg-transparent border-none" 
      appendTo="body">
      
      <div class="relative bg-transparent p-0 flex flex-col items-center justify-center select-none" (click)="$event.stopPropagation()">
        
        <ng-container *ngIf="selectedImageUrl">
          <!-- PDF preview -->
          <div *ngIf="selectedImageUrl.toLowerCase().endsWith('.pdf'); else normalImgOrOcclusion" class="relative w-[90vw] h-[85vh] bg-white rounded-2xl overflow-hidden shadow-2xl">
            <button class="absolute top-4 right-4 z-10 w-8 h-8 rounded-full bg-black/60 text-white flex items-center justify-center hover:bg-black/80 transition-colors border-none cursor-pointer shadow-md" (click)="displayImageDialog = false">
              <i class="pi pi-times text-xs"></i>
            </button>
            <iframe [src]="sanitizeUrl(selectedImageUrl)" class="w-full h-full border-none"></iframe>
          </div>

          <!-- Image & Occlusion Preview -->
          <ng-template #normalImgOrOcclusion>
            <div class="relative rounded-2xl overflow-hidden shadow-2xl mx-auto flex items-center justify-center bg-transparent" style="width: fit-content; height: fit-content; max-width: 95vw; max-height: 90vh;">
              <!-- Close button on top-right corner of image -->
              <button 
                class="absolute top-3 right-3 z-30 w-8 h-8 rounded-full bg-black/60 hover:bg-black/85 text-white flex items-center justify-center transition-all border-none cursor-pointer shadow-lg backdrop-blur-xs active:scale-95" 
                (click)="displayImageDialog = false"
                title="Tutup">
                <i class="pi pi-times text-xs"></i>
              </button>

              <!-- Image with Occlusions -->
              <ng-container *ngIf="currentFlashcard?.type === 'image'; else normalImgOnly">
                <img [src]="selectedImageUrl" class="block select-none max-h-[85vh] max-w-[95vw] w-auto h-auto object-contain rounded-2xl" />
                
                <!-- Occlusion Masks in Zoom Dialog -->
                <div *ngFor="let rect of occlusions; let idx = index" 
                     (click)="revealOcclusion(idx, $event)"
                     [style.left.%]="rect.x"
                     [style.top.%]="rect.y"
                     [style.width.%]="(isFlipped || revealedOcclusions[idx]) ? null : rect.w"
                     [style.min-width.%]="rect.w"
                     [style.height.%]="(isFlipped || revealedOcclusions[idx]) ? null : rect.h"
                     [style.min-height.%]="rect.h"
                     [style.max-width]="'92%'"
                     [class]="(isFlipped || revealedOcclusions[idx]) 
                       ? 'absolute bg-[#5B92ED] text-white border-2 border-white/90 flex items-center justify-center font-bold text-xs md:text-sm rounded-xl shadow-lg px-2.5 py-1.5 whitespace-nowrap select-none w-max z-20 transition-all cursor-pointer'
                       : 'absolute bg-[#5B92ED] border border-white/80 flex items-center justify-center text-white font-extrabold text-xs rounded-xl shadow-xs cursor-pointer select-none z-20 transition-all'">
                  <span>{{ (isFlipped || revealedOcclusions[idx]) ? (rect.label || 'Area ' + (idx + 1)) : '...' }}</span>
                </div>
              </ng-container>

              <!-- Normal Image without Occlusion -->
              <ng-template #normalImgOnly>
                <img [src]="selectedImageUrl" class="block select-none max-h-[85vh] max-w-[95vw] w-auto h-auto object-contain rounded-2xl" alt="Preview Image" />
              </ng-template>
            </div>
          </ng-template>
        </ng-container>

      </div>
    </p-dialog>

    <!-- Custom Session Modal (PrimeNG p-dialog) -->
  `,
  styles: [`
    ::ng-deep .flashcard-text-container, 
    ::ng-deep .flashcard-rich-content {
      width: 100%;
      text-align: center !important;
      word-break: normal !important;
      overflow-wrap: normal !important;
      word-wrap: normal !important;
      hyphens: none !important;
      -webkit-hyphens: none !important;

      ol, ul {
        text-align: left !important;
        margin: 0.5rem auto !important;
        padding-left: 1.75rem !important;
        list-style-position: outside !important;
        display: block !important;
      }
      ol {
        list-style-type: decimal !important;
      }
      ul {
        list-style-type: disc !important;
      }
      li {
        text-align: left !important;
        margin-bottom: 0.2rem !important;
        line-height: 1.4 !important;
        padding-left: 0.25rem !important;
      }
      p {
        margin-top: 0.15rem !important;
        margin-bottom: 0.25rem !important;
        line-height: 1.35 !important;
        text-align: center !important;
      }
    }

    ::ng-deep .flashcard-question-text,
    ::ng-deep .flashcard-question-text p,
    ::ng-deep .flashcard-question-text span:not(.marker-badge),
    ::ng-deep .flashcard-question-text div,
    ::ng-deep .flashcard-question-text li,
    ::ng-deep .flashcard-question-text h1,
    ::ng-deep .flashcard-question-text h2,
    ::ng-deep .flashcard-question-text h3,
    ::ng-deep .flashcard-question-text h4,
    ::ng-deep .flashcard-question-text h5,
    ::ng-deep .flashcard-question-text h6,
    ::ng-deep .flashcard-question-text strong,
    ::ng-deep .flashcard-question-text b,
    ::ng-deep .flashcard-question-text em,
    ::ng-deep .flashcard-question-text i {
      font-size: 20px !important;
      line-height: 1.5 !important;
      word-break: normal !important;
      overflow-wrap: normal !important;
      word-wrap: normal !important;
      hyphens: none !important;
      -webkit-hyphens: none !important;
    }

    ::ng-deep .flashcard-answer-text,
    ::ng-deep .flashcard-answer-text p,
    ::ng-deep .flashcard-answer-text span:not(.marker-badge),
    ::ng-deep .flashcard-answer-text div,
    ::ng-deep .flashcard-answer-text li,
    ::ng-deep .flashcard-answer-text h1,
    ::ng-deep .flashcard-answer-text h2,
    ::ng-deep .flashcard-answer-text h3,
    ::ng-deep .flashcard-answer-text h4,
    ::ng-deep .flashcard-answer-text h5,
    ::ng-deep .flashcard-answer-text h6,
    ::ng-deep .flashcard-answer-text strong,
    ::ng-deep .flashcard-answer-text b,
    ::ng-deep .flashcard-answer-text em,
    ::ng-deep .flashcard-answer-text i {
      font-size: 18px !important;
      line-height: 1.5 !important;
      word-break: normal !important;
      overflow-wrap: normal !important;
      word-wrap: normal !important;
      hyphens: none !important;
      -webkit-hyphens: none !important;
    }

    @media (max-width: 768px) {
      ::ng-deep .flashcard-question-text,
      ::ng-deep .flashcard-question-text p,
      ::ng-deep .flashcard-question-text span:not(.marker-badge),
      ::ng-deep .flashcard-question-text div,
      ::ng-deep .flashcard-question-text li {
        font-size: 15px !important;
        line-height: 1.4 !important;
      }

      ::ng-deep .flashcard-answer-text,
      ::ng-deep .flashcard-answer-text p,
      ::ng-deep .flashcard-answer-text span:not(.marker-badge),
      ::ng-deep .flashcard-answer-text div,
      ::ng-deep .flashcard-answer-text li {
        font-size: 14px !important;
        line-height: 1.4 !important;
      }
    }

    ::ng-deep .flashcard-question-text .marker-badge,
    ::ng-deep .flashcard-answer-text .marker-badge {
      font-size: 12px !important;
    }

    ::ng-deep .transparent-image-dialog.p-dialog {
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
    }
    ::ng-deep .transparent-image-dialog .p-dialog-content {
      background: transparent !important;
      padding: 0 !important;
      overflow: visible !important;
    }

    input[type=range]::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: #3B82F6;
      cursor: pointer;
      box-shadow: 0 1px 4px rgba(59, 130, 246, 0.4);
      border: 2px solid #FFFFFF;
    }
    input[type=range]::-moz-range-thumb {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: #3B82F6;
      cursor: pointer;
      box-shadow: 0 1px 4px rgba(59, 130, 246, 0.4);
      border: 2px solid #FFFFFF;
    }

    /* ==========================================
       CUSTOM SESSION MODAL (no p-dialog needed)
       ========================================== */
    .custom-modal-overlay {
      position: fixed;
      inset: 0;
      background: rgba(15, 23, 42, 0.5);
      backdrop-filter: blur(4px);
      -webkit-backdrop-filter: blur(4px);
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
      animation: fadeIn 0.15s ease;
    }

    .custom-modal-panel {
      background: #ffffff;
      border-radius: 1.5rem;
      padding: 1.75rem;
      width: 100%;
      max-width: 440px;
      max-height: 90vh;
      overflow-y: auto;
      box-shadow: 0 25px 60px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0,0,0,0.04);
      animation: slideUp 0.2s ease;
      position: relative;
    }

    @keyframes fadeIn {
      from { opacity: 0; }
      to   { opacity: 1; }
    }

    @keyframes slideUp {
      from { opacity: 0; transform: translateY(20px) scale(0.97); }
      to   { opacity: 1; transform: translateY(0) scale(1); }
    }

    ::ng-deep body.fullscreen-flashcard {
      .layout-topbar {
        display: none !important;
      }
      .layout-sidebar {
        display: none !important;
      }
      .layout-main-container {
        margin-left: 0 !important;
        padding: 0 !important;
        max-width: 100vw !important;
        min-height: 100vh !important;
      }
      .layout-main {
        padding: 0 !important;
        margin: 0 !important;
      }
      .layout-footer {
        display: none !important;
      }
    }

    /* ================================================================
       CARD BODY ROW — CSS Grid so columns are 100% independent.
       Text column scrolls freely; image column NEVER shifts or resizes.
     ================================================================ */
    .fc-body-row {
      /* Mobile: single column, image below text */
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
      height: 100%;
      box-sizing: border-box;
    }

    @media (min-width: 768px) {
      .fc-body-row {
        /* Desktop: CSS Grid — image column width is HARD-CODED, text takes the rest */
        display: grid;
        grid-template-columns: 1fr 340px;
        grid-template-rows: 1fr;
        gap: 1.25rem;
        align-items: start;
      }
      .fc-body-row.no-image {
        grid-template-columns: 1fr;
      }
    }

     /* Text column — stretches to fill grid cell so overflow-y:auto works */
    .fc-text-col {
      min-height: 0;
      min-width: 0;
      /* Mobile: fill remaining column height */
      flex: 1 1 0;
      overflow-y: auto;
    }

    @media (min-width: 768px) {
      .fc-text-col {
        /* Desktop: override align-items:start so THIS column stretches full row */
        align-self: stretch;
        height: 100%;
        overflow-y: auto;
      }
    }

    /* ================================================================
       IMAGE SECTION — sits inside the 260px grid column on desktop.
       On mobile it has a fixed pixel height so it never shifts either.
     ================================================================ */
    .image-section-container {
      /* Mobile: fixed height strip */
      width: 100%;
      height: 210px;
      min-height: 210px;
      max-height: 210px;
      flex-shrink: 0;
      flex-grow: 0;
      display: flex;
      flex-direction: row;   /* main image | thumb strip */
      gap: 0.4rem;
      overflow: hidden;
      box-sizing: border-box;
      align-items: flex-start;
    }

    @media (min-width: 768px) {
      .image-section-container {
        /* Desktop: fills the 340px grid column, anchored at the top */
        width: 100%;
        height: auto;
        min-height: unset;
        max-height: unset;
        flex-shrink: unset;
        flex-grow: unset;
        align-items: flex-start;
      }
    }

    /* Main image area — Flex container with aspect-ratio preservation */
    .main-image-container {
      flex: 1 1 0;           /* take remaining width after thumb sidebar */
      min-width: 0;
      height: auto;
      max-height: 380px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #F8FAFC;
      border: 1px solid #E2E8F0;
      border-radius: 0.75rem;
      overflow: hidden;
      position: relative;
    }

    .main-image-preview {
      width: 100%;
      height: auto;
      max-height: 380px;
      object-fit: contain;          /* Fit the image without cropping! */
      border-radius: 0.75rem;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
      transition: transform 0.2s ease;
      display: block;
    }

    .main-image-preview:hover {
      transform: scale(1.01);
    }

    /* Vertical thumbnail strip — sits to the RIGHT of the main image with inside scrollbar */
    .thumb-sidebar {
      display: flex;
      flex-direction: column;
      gap: 0.4rem;
      overflow-y: auto;
      overflow-x: hidden;
      flex-shrink: 0;
      padding-right: 3px;
      max-height: 290px;
      scrollbar-width: thin;
      scrollbar-color: rgba(255, 255, 255, 0.45) transparent;
    }
    .thumb-sidebar::-webkit-scrollbar {
      width: 4px;
      display: block;
    }
    .thumb-sidebar::-webkit-scrollbar-track {
      background: transparent;
    }
    .thumb-sidebar::-webkit-scrollbar-thumb {
      background-color: rgba(255, 255, 255, 0.45);
      border-radius: 10px;
    }
    .thumb-sidebar::-webkit-scrollbar-thumb:hover {
      background-color: rgba(255, 255, 255, 0.75);
    }

    /* Thumbnail sidebar on question side (light background) */
    .thumb-sidebar-question {
      scrollbar-color: rgba(59, 130, 246, 0.4) transparent;
    }
    .thumb-sidebar-question::-webkit-scrollbar-thumb {
      background-color: rgba(59, 130, 246, 0.4);
    }
    .thumb-sidebar-question::-webkit-scrollbar-thumb:hover {
      background-color: rgba(59, 130, 246, 0.7);
    }

    ::ng-deep .card-side-by-side .flashcard-text-container {
      text-align: left !important;
      word-break: normal !important;
      overflow-wrap: normal !important;
      word-wrap: normal !important;
      hyphens: none !important;
      -webkit-hyphens: none !important;
    }
    .card-side-by-side .flashcard-text-container > div {
      text-align: left !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
    .card-side-by-side img,
    .flashcard-main-image {
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
    }

    .thumb-item {
      width: 40px;
      height: 40px;
      min-width: 40px;
      min-height: 40px;
      border-radius: 0.45rem;
      overflow: hidden;
      border: 2px solid rgba(255, 255, 255, 0.35);
      cursor: pointer;
      transition: all 0.2s ease;
      opacity: 0.75;
      flex-shrink: 0;
    }
    .thumb-sidebar-question .thumb-item {
      border-color: #CBD5E1;
    }
    .thumb-item:hover {
      opacity: 1;
      border-color: #64748B;
    }
    .thumb-item.active {
      border-color: #FFFFFF;
      opacity: 1;
      transform: scale(1.05);
      box-shadow: 0 0 8px rgba(255, 255, 255, 0.55);
    }
    .thumb-sidebar-question .thumb-item.active {
      border-color: #2563EB;
      box-shadow: 0 0 8px rgba(37, 99, 235, 0.35);
    }

    /* Custom thin scrollbar */
    .scrollbar-thin::-webkit-scrollbar {
      width: 6px;
    }
    .scrollbar-thin::-webkit-scrollbar-track {
      background: transparent;
    }
    .scrollbar-thin::-webkit-scrollbar-thumb {
      background-color: rgba(255, 255, 255, 0.45);
      border-radius: 20px;
    }
    .scrollbar-thin::-webkit-scrollbar-thumb:hover {
      background-color: rgba(255, 255, 255, 0.75);
    }
    .scrollbar-thin {
      scrollbar-width: thin;
      scrollbar-color: rgba(255, 255, 255, 0.45) transparent;
    }

    /* Dynamic scrollbar: only visible while scrolling inside fixed 483px card */
    .card-scroll-dynamic {
      overflow-y: auto;
      scrollbar-width: none;       /* Firefox default hidden */
      -ms-overflow-style: none;    /* IE/Edge */
    }

    .card-scroll-dynamic::-webkit-scrollbar {
      width: 6px;
    }

    .card-scroll-dynamic::-webkit-scrollbar-track {
      background: transparent;
    }

    .card-scroll-dynamic::-webkit-scrollbar-thumb {
      background-color: transparent;
      border-radius: 9999px;
      transition: background-color 0.25s ease;
    }

    /* While scrolling on Question side */
    .card-scroll-dynamic.is-scrolling::-webkit-scrollbar-thumb {
      background-color: rgba(59, 130, 246, 0.4);
    }
    .card-scroll-dynamic.is-scrolling::-webkit-scrollbar-thumb:hover {
      background-color: rgba(59, 130, 246, 0.7);
    }

    /* While scrolling on Answer side (blue background) */
    .card-flipped-active .card-scroll-dynamic.is-scrolling::-webkit-scrollbar-thumb {
      background-color: rgba(255, 255, 255, 0.45);
    }
    .card-flipped-active .card-scroll-dynamic.is-scrolling::-webkit-scrollbar-thumb:hover {
      background-color: rgba(255, 255, 255, 0.75);
    }

    /* Firefox during scrolling */
    .card-scroll-dynamic.is-scrolling {
      scrollbar-width: thin;
      scrollbar-color: rgba(59, 130, 246, 0.4) transparent;
    }
    .card-flipped-active .card-scroll-dynamic.is-scrolling {
      scrollbar-color: rgba(255, 255, 255, 0.45) transparent;
    }

    .fc-description-content ::ng-deep p {
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
    }
    .fc-description-content ::ng-deep ul, 
    .fc-description-content ::ng-deep ol {
      text-align: left;
      display: inline-block;
      margin: 0.5rem auto;
      padding-left: 1.5rem;
    }
    .fc-description-content ::ng-deep li {
      margin-bottom: 0.25rem;
    }
  `]
})
export class FlashcardShowComponent implements OnInit, OnDestroy, AfterViewInit {
  flashcards: Flashcard[] = [];
  categories: FlashcardCategory[] = [];
  currentIndex: number = 0;
  loading: boolean = false;
  selectedCategoryId: string | null = null;
  selectedCategory: FlashcardCategory | null = null;
  isFlipped: boolean = false;
  searchQuery: string = '';
  categorySearchQuery: string = '';
  categoryCounts: { [key: string]: number } = {};
  displayImageDialog: boolean = false;
  customCategoryNames: string[] = [];

  // Occlusion fields
  occlusions: any[] = [];
  revealedOcclusions: { [key: number]: boolean } = {};
  userAnswerLabels: string[] = [];
  selectedImageUrl: string = '';
  activeQuestionImgIndex: number = 0;
  activeAnswerImgIndex: number = 0;
  questionImages: string[] = [];
  answerImages: string[] = [];
  userId: string | null = null;
  isFullscreen: boolean = false;

  get isOcclusionCard(): boolean {
    if (this.currentFlashcard?.type === 'image') return true;
    if (this.currentFlashcard?.description && typeof this.currentFlashcard.description === 'string') {
      const trimmed = this.currentFlashcard.description.trim();
      if (trimmed.startsWith('[{') && trimmed.endsWith('}]')) {
        return true;
      }
    }
    return false;
  }

  get hasQuestionImages(): boolean {
    return !!(this.questionImages && this.questionImages.length > 0);
  }

  get hasAnswerImages(): boolean {
    return !!(this.answerImages && this.answerImages.length > 0);
  }

  get hasActiveImages(): boolean {
    if (this.isOcclusionCard) return true;
    if (!this.isFlipped) {
      return this.hasQuestionImages;
    } else {
      return this.hasAnswerImages;
    }
  }

  @ViewChild('cardContentContainer') cardContentContainer?: ElementRef<HTMLDivElement>;
  @ViewChild('imageScrollContainer') imageScrollContainer?: ElementRef<HTMLDivElement>;
  cardScrollTimeout: any = null;
  isCardScrolling: boolean = false;

  onCardScroll(): void {
    this.isCardScrolling = true;
    if (this.cardScrollTimeout) {
      clearTimeout(this.cardScrollTimeout);
    }
    this.cardScrollTimeout = setTimeout(() => {
      this.isCardScrolling = false;
      this.cdr.markForCheck();
    }, 1000);
  }

  onCardWheel(event: WheelEvent): void {
    if (!this.hasActiveImages) return;
    const el = this.imageScrollContainer?.nativeElement;
    if (!el || el.scrollHeight <= el.clientHeight) return;

    if (!el.contains(event.target as Node)) {
      el.scrollTop += event.deltaY;
      this.onCardScroll();
      event.preventDefault();
    }
  }

  resetCardScroll(): void {
    if (this.cardContentContainer && this.cardContentContainer.nativeElement) {
      this.cardContentContainer.nativeElement.scrollTop = 0;
    }
    if (this.imageScrollContainer && this.imageScrollContainer.nativeElement) {
      this.imageScrollContainer.nativeElement.scrollTop = 0;
    }
    this.isCardScrolling = false;
    if (this.cardScrollTimeout) {
      clearTimeout(this.cardScrollTimeout);
      this.cardScrollTimeout = null;
    }
  }

  toggleFullscreen(): void {
    this.isFullscreen = !this.isFullscreen;
    this.updateFullscreenClass();
  }

  updateFullscreenClass(): void {
    if (this.isFullscreen) {
      document.body.classList.add('fullscreen-flashcard');
    } else {
      document.body.classList.remove('fullscreen-flashcard');
    }
  }
  userAnswerText: string = '';
  showInstruction: boolean = true;
  selectedRating: string = 'Baik';

  // Session config properties
  isConfiguringSession: boolean = false;
  sessionType: 'new' | 'worked' | 'all' = 'all';
  sessionLimit: number | 'all' = 10;
  allFlashcards: Flashcard[] = [];

  categoryStats: {
    [categoryId: string]: {
      total: number;
      ulang: number;
      sulit: number;
      baik: number;
      mudah: number;
      worked: number;
    }
  } = {};

  navigateToAdmin(): void {
    this.router.navigate(['/app/flashcards']);
  }

  showAllTopicsProgress: boolean = false;

  getStatPercent(val: number | undefined, total: number | undefined): number {
    if (!val || !total || total === 0) return 0;
    return Math.round((val / total) * 100);
  }

  formatTopicName(name: string): string {
    if (!name) return '';
    return name.toLowerCase().replace(/(?:^|\s|-|\/)\S/g, (char) => char.toUpperCase());
  }

  get donutSeg1() {
    const t = this.totalStats.worked || this.totalStats.total || 0;
    if (!t) return { dash: '0 326.726', offset: 0 };
    const len = (this.totalStats.mudah / t) * 326.726;
    return { dash: `${len} ${326.726 - len}`, offset: 0 };
  }

  get donutSeg2() {
    const t = this.totalStats.worked || this.totalStats.total || 0;
    if (!t) return { dash: '0 326.726', offset: 0 };
    const len1 = (this.totalStats.mudah / t) * 326.726;
    const len2 = (this.totalStats.baik / t) * 326.726;
    return { dash: `${len2} ${326.726 - len2}`, offset: -len1 };
  }

  get donutSeg3() {
    const t = this.totalStats.worked || this.totalStats.total || 0;
    if (!t) return { dash: '0 326.726', offset: 0 };
    const len1 = (this.totalStats.mudah / t) * 326.726;
    const len2 = (this.totalStats.baik / t) * 326.726;
    const len3 = (this.totalStats.sulit / t) * 326.726;
    return { dash: `${len3} ${326.726 - len3}`, offset: -(len1 + len2) };
  }

  get donutSeg4() {
    const t = this.totalStats.worked || this.totalStats.total || 0;
    if (!t) return { dash: '0 326.726', offset: 0 };
    const len1 = (this.totalStats.mudah / t) * 326.726;
    const len2 = (this.totalStats.baik / t) * 326.726;
    const len3 = (this.totalStats.sulit / t) * 326.726;
    const len4 = (this.totalStats.ulang / t) * 326.726;
    return { dash: `${len4} ${326.726 - len4}`, offset: -(len1 + len2 + len3) };
  }

  get totalStats() {
    let total = 0;
    let ulang = 0;
    let sulit = 0;
    let baik = 0;
    let mudah = 0;
    let worked = 0;
    Object.keys(this.categoryStats).forEach(key => {
      const s = this.categoryStats[key];
      total += s.total;
      ulang += s.ulang;
      sulit += s.sulit;
      baik += s.baik;
      mudah += s.mudah;
      worked += s.worked;
    });
    return { total, ulang, sulit, baik, mudah, worked };
  }

  get categoriesWithProgress(): FlashcardCategory[] {
    let list = this.categories.filter(c => c.id && this.categoryStats[c.id] && this.categoryStats[c.id].worked > 0);
    if (this.categorySearchQuery) {
      const query = this.categorySearchQuery.toLowerCase();
      list = list.filter(c => c.name.toLowerCase().includes(query));
    }
    return list;
  }

  get hasWorkedCategories(): boolean {
    return this.categoriesWithProgress.length > 0;
  }

  get newCardsCount(): number {
    return this.allFlashcards.filter(f => !f.answer_id).length;
  }

  get workedCardsCount(): number {
    return this.allFlashcards.filter(f => f.answer_id).length;
  }

  get dueCardsCount(): number {
    return this.allFlashcards.filter(f => !f.answer_id || this.isCardDue(f.next_review)).length;
  }

  isCardDue(nextReviewStr: string | null | undefined): boolean {
    if (!nextReviewStr) return true;
    try {
      const isoStr = nextReviewStr.trim().replace(' ', 'T') + 'Z';
      const nextReviewDate = new Date(isoStr);
      const now = new Date();
      return nextReviewDate <= now;
    } catch (e) {
      return true;
    }
  }

  getSelectedModeCount(): number {
    if (this.sessionType === 'new') {
      return this.newCardsCount;
    } else if (this.sessionType === 'worked') {
      return this.allFlashcards.length;
    } else {
      return this.allFlashcards.length;
    }
  }

  setSessionLimit(val: number | 'all'): void {
    if (val === 'all') {
      this.sessionLimit = 'all';
    } else {
      const max = this.getSelectedModeCount();
      this.sessionLimit = Math.min(max, val);
    }
  }

  onSessionLimitSliderChange(event: Event): void {
    const val = Number((event.target as HTMLInputElement).value);
    const max = this.getSelectedModeCount();
    if (val >= max) {
      this.sessionLimit = 'all';
    } else {
      this.sessionLimit = val;
    }
  }

  getMarkLeftPercent(val: number): number {
    const max = this.getSelectedModeCount();
    if (max <= 1) return 0;
    const pct = ((val - 1) / (max - 1)) * 100;
    return Math.max(0, Math.min(100, pct));
  }

  getSliderPercent(): number {
    const max = this.getSelectedModeCount();
    if (max <= 1) return 100;
    const current = this.sessionLimit === 'all' ? max : Number(this.sessionLimit);
    return this.getMarkLeftPercent(current);
  }

  getSelectedModeLimitCount(): number {
    const totalAvailable = this.getSelectedModeCount();
    if (this.sessionLimit === 'all') return totalAvailable;
    return Math.min(totalAvailable, Number(this.sessionLimit));
  }

  filterFlashcardsByMode(type: 'new' | 'worked' | 'all'): Flashcard[] {
    if (type === 'new') {
      return this.allFlashcards.filter(f => !f.answer_id);
    } else if (type === 'worked') {
      return this.allFlashcards;
    } else {
      return this.allFlashcards;
    }
  }

  startSession(): void {
    const filtered = this.filterFlashcardsByMode(this.sessionType);
    if (filtered.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'Perhatian', detail: 'Tidak ada flashcard yang cocok dengan kriteria pilihan Anda.' });
      return;
    }

    const now = new Date();
    const sorted = [...filtered].sort((a, b) => {
      const aIsDue = !a.answer_id || this.isCardDue(a.next_review);
      const bIsDue = !b.answer_id || this.isCardDue(b.next_review);

      if (aIsDue && !bIsDue) return -1;
      if (!aIsDue && bIsDue) return 1;

      if (a.next_review && b.next_review) {
        try {
          const isoA = a.next_review.trim().replace(' ', 'T') + 'Z';
          const isoB = b.next_review.trim().replace(' ', 'T') + 'Z';
          const timeA = new Date(isoA).getTime();
          const timeB = new Date(isoB).getTime();
          if (timeA !== timeB) return timeA - timeB;
        } catch (e) { }
      }

      const orderA = a.order_number ? Number(a.order_number) : 0;
      const orderB = b.order_number ? Number(b.order_number) : 0;
      return orderA - orderB;
    });

    const finalLimit = this.getSelectedModeLimitCount();
    this.flashcards = sorted.slice(0, finalLimit);

    this.currentIndex = 0;
    this.isFlipped = false;
    this.isConfiguringSession = false;
    this.isFullscreen = false;
    this.updateFullscreenClass();
    this.resetImageIndices();
    this.updateCurrentImages();
    this.updateUserAnswerText();
    this.resetCardScroll();
  }

  changeSessionType(type: 'new' | 'worked' | 'all'): void {
    this.sessionType = type;

    if (type === 'all') {
      this.sessionLimit = 'all';
      return;
    }

    // Auto-adjust sessionLimit if current limit is greater than available count in the new type
    const count = this.getSelectedModeCount();
    if (this.sessionLimit !== 'all' && Number(this.sessionLimit) > count) {
      const limits = [50, 30, 20, 10];
      const validLimit = limits.find(l => count >= l);
      if (validLimit) {
        this.sessionLimit = validLimit;
      } else {
        this.sessionLimit = 'all';
      }
    }
  }

  // Custom Session controller properties
  displayCustomSessionDialog: boolean = false;
  selectedCustomRatings: string[] = [];
  selectedCustomCategories: string[] = [];
  customCategorySearchQuery: string = '';
  isModalJustOpened: boolean = false;

  openCustomSessionDialog(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    console.log('openCustomSessionDialog called!');
    this.selectedCustomRatings = ['ulang', 'sulit', 'baik', 'mudah'];
    this.selectedCustomCategories = [];
    this.customCategorySearchQuery = '';
    this.displayCustomSessionDialog = true;
    this.cdr.detectChanges();
  }

  closeCustomSessionDialog(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.displayCustomSessionDialog = false;
  }

  get areAllCustomCategoriesSelected(): boolean {
    if (!this.categories || this.categories.length === 0) return false;
    return this.categories.every(c => c.id !== undefined && c.id !== null && this.selectedCustomCategories.includes(String(c.id)));
  }

  toggleSelectAllCustomCategories(): void {
    if (this.areAllCustomCategoriesSelected) {
      this.selectedCustomCategories = [];
    } else {
      this.selectedCustomCategories = this.categories
        .filter(c => c.id !== undefined && c.id !== null)
        .map(c => String(c.id));
    }
  }

  get filteredCustomCategories(): FlashcardCategory[] {
    if (!this.customCategorySearchQuery) return this.categories;
    const query = this.customCategorySearchQuery.toLowerCase();
    return this.categories.filter(c =>
      c.name.toLowerCase().includes(query)
    );
  }

  toggleCustomRating(rating: string): void {
    const idx = this.selectedCustomRatings.indexOf(rating);
    if (idx > -1) {
      this.selectedCustomRatings.splice(idx, 1);
    } else {
      this.selectedCustomRatings.push(rating);
    }
  }

  toggleCustomCategory(id: any): void {
    if (id === undefined || id === null) return;
    const strId = String(id);
    const idx = this.selectedCustomCategories.indexOf(strId);
    if (idx > -1) {
      this.selectedCustomCategories.splice(idx, 1);
    } else {
      this.selectedCustomCategories.push(strId);
    }
  }

  isCustomRatingSelected(rating: string): boolean {
    return this.selectedCustomRatings.includes(rating);
  }

  isCustomCategorySelected(id: any): boolean {
    if (id === undefined || id === null) return false;
    return this.selectedCustomCategories.includes(String(id));
  }

  get isCustomSessionValid(): boolean {
    return this.selectedCustomRatings.length > 0 && this.selectedCustomCategories.length > 0;
  }

  getCategoryPillStyle(idx: number, isSelected: boolean): string {
    if (!isSelected) {
      return 'inline-flex items-center px-4 py-2 bg-white border border-[#E2E8F0] text-[#475569] rounded-full text-sm font-semibold cursor-pointer transition-all active:scale-95';
    }
    const styles = [
      'inline-flex items-center px-4 py-2 bg-[#EFF6FF] border border-[#3B82F6]/60 text-[#2563EB] rounded-full text-sm font-bold cursor-pointer transition-all active:scale-95 shadow-sm',
      'inline-flex items-center px-4 py-2 bg-[#F0FDF4] border border-[#10B981]/60 text-[#16A34A] rounded-full text-sm font-bold cursor-pointer transition-all active:scale-95 shadow-sm',
      'inline-flex items-center px-4 py-2 bg-[#FFF8F0] border border-[#F59E0B]/60 text-[#D97706] rounded-full text-sm font-bold cursor-pointer transition-all active:scale-95 shadow-sm',
      'inline-flex items-center px-4 py-2 bg-[#FEF2F2] border border-[#EF4444]/60 text-[#DC2626] rounded-full text-sm font-bold cursor-pointer transition-all active:scale-95 shadow-sm',
      'inline-flex items-center px-4 py-2 bg-[#FAF5FF] border border-[#A855F7]/60 text-[#9333EA] rounded-full text-sm font-bold cursor-pointer transition-all active:scale-95 shadow-sm'
    ];
    return styles[idx % styles.length];
  }

  startCustomSession(): void {
    if (!this.isCustomSessionValid) return;
    this.displayCustomSessionDialog = false;
    this.loading = true;

    const categoryIdsStr = this.selectedCustomCategories.join(',');
    const ratingsStr = this.selectedCustomRatings.join(',');

    this.flashcardService.getFlashcardsCustom(categoryIdsStr, ratingsStr, this.userId || undefined).subscribe({
      next: (results) => {
        if (!results || results.length === 0) {
          this.loading = false;
          this.messageService.add({ severity: 'warn', summary: 'Perhatian', detail: 'Tidak ada flashcard yang cocok dengan kriteria pilihan Anda.' });
          return;
        }

        // Sort via Spaced Repetition logic
        const now = new Date();
        const sorted = [...results].sort((a, b) => {
          const aIsDue = !a.answer_id || this.isCardDue(a.next_review);
          const bIsDue = !b.answer_id || this.isCardDue(b.next_review);

          if (aIsDue && !bIsDue) return -1;
          if (!aIsDue && bIsDue) return 1;

          if (a.next_review && b.next_review) {
            try {
              const isoA = a.next_review.trim().replace(' ', 'T') + 'Z';
              const isoB = b.next_review.trim().replace(' ', 'T') + 'Z';
              const timeA = new Date(isoA).getTime();
              const timeB = new Date(isoB).getTime();
              if (timeA !== timeB) return timeA - timeB;
            } catch (e) { }
          }

          const orderA = a.order_number ? Number(a.order_number) : 0;
          const orderB = b.order_number ? Number(b.order_number) : 0;
          return orderA - orderB;
        });

        this.allFlashcards = sorted;
        this.flashcards = sorted;
        this.selectedCategory = {
          name: 'Custom Session',
          description: 'Sesi belajar khusus pilihan Anda'
        };

        this.currentIndex = 0;
        this.isFlipped = false;
        this.isConfiguringSession = false;
        this.isFullscreen = false;
        this.updateFullscreenClass();
        this.resetImageIndices();
        this.updateCurrentImages();
        this.updateUserAnswerText();
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        console.error('Error loading custom session flashcards:', err);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal memuat kartu custom session' });
      }
    });
  }

  getCategoryInitial(name: string): string {
    return name ? name.charAt(0).toUpperCase() : '';
  }

  stripHtml(html: string): string {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  get hasClozePattern(): boolean {
    if (!this.currentFlashcard || !this.currentFlashcard.text) return false;
    return /\[\s*\.*?\s*\]|\[\s*\_+\s*\]|\[\s*\…\s*\]/g.test(this.currentFlashcard.text);
  }

  cleanTextBreaks(val: string): string {
    if (!val) return '';
    return val
      .replace(/&shy;|\u00ad/gi, '')
      .replace(/[\u200b\u200c\u200d\ufeff]/g, '')
      .replace(/&nbsp;|\u00a0/gi, ' ');
  }

  formatCardText(raw: string, isAnswer: boolean = false): string {
    if (!raw) return '';
    let text = this.cleanTextBreaks(raw.trim());

    // 1. If text contains HTML list tags like <ol> or <ul>, parse them into pill/badge list items
    if (/<(ol|ul)\b[^>]*>/i.test(text)) {
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');
        const lists = doc.querySelectorAll('ol, ul');

        lists.forEach(listEl => {
          const isOrdered = listEl.tagName.toLowerCase() === 'ol';
          const items = listEl.querySelectorAll('li');
          const wrapper = doc.createElement('div');
          wrapper.className = 'space-y-2.5 text-left w-full max-w-4xl lg:max-w-5xl xl:max-w-6xl mx-auto my-1.5';

          items.forEach((li, idx) => {
            const row = doc.createElement('div');
            row.className = 'flex items-start gap-2.5';

            let markerHtml = '';
            if (isOrdered) {
              const markerText = (idx + 1).toString();
              markerHtml = `<span class="marker-badge inline-flex items-center justify-center min-w-[24px] h-6 px-1.5 rounded-lg ${isAnswer ? 'bg-white/20 text-white border border-white/30 font-bold text-xs' : 'bg-blue-100 text-[#2563EB] font-bold text-xs'} shrink-0 mt-0.5 select-none">${markerText}</span>`;
            } else {
              markerHtml = `<span class="w-2 h-2 rounded-full ${isAnswer ? 'bg-white/90 mt-2' : 'bg-[#4C85EC] mt-2'} shrink-0"></span>`;
            }

            const contentSpan = doc.createElement('span');
            contentSpan.className = isAnswer ? 'text-white text-sm sm:text-base leading-relaxed' : 'text-slate-800 text-sm sm:text-base font-semibold leading-relaxed';
            contentSpan.innerHTML = li.innerHTML;

            row.innerHTML = markerHtml;
            row.appendChild(contentSpan);
            wrapper.appendChild(row);
          });

          listEl.replaceWith(wrapper);
        });

        return doc.body.innerHTML;
      } catch (e) {
        console.error('Error parsing HTML list:', e);
      }
    }

    // 2. Auto-detect inline list markers like " a. ", " b. ", " 1. ", " 2. ", " - ", " • "
    const listMarkerRegex = /(?<=\S)\s+([a-zA-Z]\.|\d+[\.\)]|\-|\•)\s+/g;
    text = text.replace(listMarkerRegex, '\n$1 ');

    // Normalize newlines
    text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');

    // Split into lines
    const lines = text.split('\n').map(l => l.trim()).filter(l => l.length > 0);

    // Check if lines are list items
    const listItemPattern = /^([a-zA-Z]\.|\d+[\.\)]|\-|\•)\s*(.*)$/;
    const hasListItems = lines.filter(l => listItemPattern.test(l)).length >= 2 || (lines.length === 1 && listItemPattern.test(lines[0]));

    if (hasListItems) {
      let listHtml = `<div class="space-y-2.5 text-left w-full max-w-4xl lg:max-w-5xl xl:max-w-6xl mx-auto my-1.5">`;
      for (const line of lines) {
        const match = line.match(listItemPattern);
        if (match) {
          const marker = match[1];
          const content = match[2];
          if (marker === '-' || marker === '•') {
            listHtml += `
              <div class="flex items-start gap-2.5">
                <span class="w-2 h-2 rounded-full ${isAnswer ? 'bg-white/90 mt-2' : 'bg-[#4C85EC] mt-2'} shrink-0"></span>
                <span class="${isAnswer ? 'text-white text-sm sm:text-base leading-relaxed' : 'text-slate-800 text-sm sm:text-base font-semibold leading-relaxed'}">${content}</span>
              </div>`;
          } else {
            const cleanMarker = marker.replace(/[\.\)]/, '');
            listHtml += `
              <div class="flex items-start gap-2.5">
                <span class="marker-badge inline-flex items-center justify-center min-w-[24px] h-6 px-1.5 rounded-lg ${isAnswer ? 'bg-white/20 text-white border border-white/30 font-bold text-xs' : 'bg-blue-100 text-[#2563EB] font-bold text-xs'} shrink-0 mt-0.5 select-none">${cleanMarker}</span>
                <span class="${isAnswer ? 'text-white text-sm sm:text-base leading-relaxed' : 'text-slate-800 text-sm sm:text-base font-semibold leading-relaxed'}">${content}</span>
              </div>`;
          }
        } else {
          listHtml += `
            <div class="${isAnswer ? 'text-white text-sm sm:text-base leading-relaxed pl-8' : 'text-slate-800 text-sm sm:text-base font-semibold leading-relaxed pl-8'}">
              ${line}
            </div>`;
        }
      }
      listHtml += `</div>`;
      return listHtml;
    }

    // If it's regular multiline text
    if (lines.length > 1) {
      const lineContent = lines.map(l => `<p class="my-0.5 sm:my-1 leading-snug">${l}</p>`).join('');
      return `<div class="${isAnswer ? 'text-white text-center' : 'text-slate-800 font-bold text-center'} max-w-4xl lg:max-w-5xl xl:max-w-6xl mx-auto px-2">${lineContent}</div>`;
    }

    // Single line plain text
    return `<div class="${isAnswer ? 'font-medium text-white leading-relaxed text-center' : 'font-bold text-slate-800 leading-relaxed text-center'} max-w-4xl lg:max-w-5xl xl:max-w-6xl mx-auto px-2">${text}</div>`;
  }

  getFormattedQuestion(): string {
    if (!this.currentFlashcard) return '';
    let text = this.cleanTextBreaks(this.currentFlashcard.text || '');

    const clozePillPlaceholder = `<span class="inline-flex items-center justify-center bg-[#C6D8F8] text-[#4F86F6] font-extrabold px-5 py-1.5 rounded-xl mx-1.5 align-middle shadow-2xs">...</span>`;

    const clozeRegex = /\[\s*\.*?\s*\]|\[\s*\_+\s*\]|\[\s*\…\s*\]/g;
    if (text.match(clozeRegex)) {
      text = text.replace(clozeRegex, clozePillPlaceholder);
      return `<div class="font-bold text-slate-800 leading-relaxed max-w-4xl lg:max-w-5xl xl:max-w-6xl mx-auto text-center px-2">${text}</div>`;
    }

    return this.formatCardText(text, false);
  }

  getFormattedAnswer(): any {
    if (!this.currentFlashcard) return '';
    if (this.isOcclusionCard) return '';

    let text = this.cleanTextBreaks(this.currentFlashcard.text || '');
    const clozeRegex = /\[\s*\.*?\s*\]|\[\s*\_+\s*\]|\[\s*\…\s*\]/g;

    if (this.hasClozePattern && text.match(clozeRegex)) {
      const rawAnswer = this.currentFlashcard.description || this.currentFlashcard.answer || '';
      const cleanAnswer = this.cleanTextBreaks(this.stripHtml(rawAnswer)).trim();
      const yellowAnswerPill = `<span class="inline-flex items-center justify-center border-2 border-[#FFE066] text-[#FFE066] font-extrabold px-4 py-1 rounded-xl mx-1.5 align-middle shadow-2xs">${cleanAnswer || '...'}</span>`;
      text = text.replace(clozeRegex, yellowAnswerPill);
      return this.sanitizer.bypassSecurityTrustHtml(`<div class="font-bold text-white leading-relaxed max-w-4xl lg:max-w-5xl xl:max-w-6xl mx-auto text-center px-2">${text}</div>`);
    }

    const answerContent = this.currentFlashcard.description || this.currentFlashcard.answer || this.currentFlashcard.text || '';
    if (typeof answerContent === 'string') {
      const trimmed = answerContent.trim();
      if (trimmed.startsWith('[{') && trimmed.endsWith('}]')) {
        return '';
      }
      return this.sanitizer.bypassSecurityTrustHtml(this.formatCardText(this.cleanTextBreaks(answerContent), true));
    }
    return this.sanitizer.bypassSecurityTrustHtml(this.formatCardText(answerContent, true));
  }

  categoryFirst: number = 0;
  categoryRows: number = 10;

  onCategoryPageChange(event: any): void {
    this.categoryFirst = event.first;
    this.categoryRows = event.rows;
  }

  get paginatedCategories(): FlashcardCategory[] {
    if (this.categoryFirst >= this.filteredCategories.length && this.filteredCategories.length > 0) {
      this.categoryFirst = 0;
    }
    const start = this.categoryFirst;
    const end = this.categoryFirst + this.categoryRows;
    return this.filteredCategories.slice(start, end);
  }

  get filteredCategories(): FlashcardCategory[] {
    if (!this.categorySearchQuery) return this.categories;
    const query = this.categorySearchQuery.toLowerCase();
    return this.categories.filter(c =>
      c.name.toLowerCase().includes(query) ||
      (c.description && c.description.toLowerCase().includes(query))
    );
  }

  selectCategoryCard(cat: FlashcardCategory): void {
    if (cat.id) {
      this.router.navigate(['/app/flashcard/show', cat.id]);
    }
  }


  get filteredFlashcards(): Flashcard[] {
    if (!this.searchQuery) return this.flashcards;
    const query = this.searchQuery.toLowerCase();
    return this.flashcards.filter(f =>
      (f.text && f.text.toLowerCase().includes(query)) ||
      (f.description && f.description.toLowerCase().includes(query)) ||
      (f.topic && f.topic.toLowerCase().includes(query))
    );
  }

  constructor(
    private flashcardService: FlashcardService,
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) { }

  ngAfterViewInit(): void {
    // Modal will be moved to body on demand in openCustomSessionDialog()
  }

  ngOnInit(): void {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        this.userId = user.ID_USER || user.id || user.id_user || user.ID_USERS || '1';
      } catch (e) {
        this.userId = '1';
      }
    } else {
      this.userId = '1';
    }
    this.loadCategories();

    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      if (id) {
        this.selectedCategoryId = id;
        if (this.categories.length > 0) {
          this.selectCategoryById(id);
        }
      } else {
        this.resetState();
        if (this.categories.length > 0) {
          this.loadCategoryCounts();
        }
      }
    });
  }

  ngOnDestroy(): void {
    document.body.classList.remove('fullscreen-flashcard');
    if (this.cardScrollTimeout) {
      clearTimeout(this.cardScrollTimeout);
      this.cardScrollTimeout = null;
    }
  }

  resetState(): void {
    this.selectedCategory = null;
    this.selectedCategoryId = null;
    this.customCategoryNames = [];
    this.flashcards = [];
    this.allFlashcards = [];
    this.currentIndex = 0;
    this.isFlipped = false;
    this.searchQuery = '';
    this.resetImageIndices();
    this.isConfiguringSession = false;
    this.revealedOcclusions = {};
    this.resetCardScroll();
  }

  selectCategoryById(id: string): void {
    const cat = this.categories.find(c => String(c.id) === String(id));
    if (cat) {
      this.selectedCategory = cat;
    } else {
      this.selectedCategory = { id: id, name: 'Flashcard', description: '' };
    }
    this.loadFlashcards();
  }

  loadCategories(): void {
    this.flashcardService.getCategories().subscribe({
      next: (data) => {
        this.categories = data;
        this.loadCategoryCounts();
        if (this.selectedCategoryId) {
          this.selectCategoryById(this.selectedCategoryId);
        }
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal memuat kategori' });
        console.error('Error loading categories:', err);
      }
    });
  }

  loadCategoryCounts(): void {
    this.flashcardService.getFlashcards(this.userId || undefined).subscribe({
      next: (allData) => {
        const grouped: { [key: string]: Flashcard[] } = {};
        allData.forEach(f => {
          const rawCatId = f.flashcard_category_id || (f as any).category_id || (f as any).ID_CATEGORY || (f as any).flashcard_category_ID;
          if (rawCatId !== undefined && rawCatId !== null) {
            const catId = String(rawCatId);
            if (!grouped[catId]) {
              grouped[catId] = [];
            }
            grouped[catId].push(f);
          }
        });

        this.categoryCounts = {};
        this.categoryStats = {};

        this.categories.forEach(cat => {
          if (cat.id) {
            const catKey = String(cat.id);
            const data = grouped[catKey] || [];
            this.categoryCounts[cat.id] = data.length;

            let ulang = 0;
            let sulit = 0;
            let baik = 0;
            let mudah = 0;
            data.forEach(f => {
              if (f.answer_id || (f as any).id_answer) {
                const status = (f.answer_status || (f as any).status || '').toLowerCase();
                if (status === 'ulang' || status === 'ulangi') ulang++;
                else if (status === 'sulit') sulit++;
                else if (status === 'baik') baik++;
                else if (status === 'mudah') mudah++;
              }
            });
            const worked = ulang + sulit + baik + mudah;
            this.categoryStats[cat.id] = {
              total: data.length,
              ulang,
              sulit,
              baik,
              mudah,
              worked
            };
          }
        });
      },
      error: (err) => {
        console.error('Error loading all flashcards for counts:', err);
      }
    });
  }

  startFlashcard(): void {
    if (this.selectedCategoryId) {
      this.selectedCategory = this.categories.find(cat => String(cat.id) === String(this.selectedCategoryId)) || null;
      this.loadFlashcards();
    }
  }

  loadFlashcards(): void {
    if (!this.selectedCategoryId) return;
    this.loading = true;
    this.flashcardService.getFlashcardsByCategory(Number(this.selectedCategoryId), this.userId || undefined, 'all', 'all').subscribe({
      next: (data) => {
        this.allFlashcards = data;
        this.flashcards = [...data];
        this.loading = false;
        this.sessionType = 'all';
        this.sessionLimit = 'all';
        this.isConfiguringSession = false;
        this.currentIndex = 0;
        this.isFlipped = false;
        this.resetImageIndices();
        this.updateCurrentImages();
        this.updateUserAnswerText();

        if (this.selectedCategory && (!this.selectedCategory.name || this.selectedCategory.name === 'Flashcard') && data.length > 0 && data[0].category_name) {
          this.selectedCategory.name = data[0].category_name;
        }

        if (this.allFlashcards.length === 0) {
          this.flashcards = [];
          this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Tidak ada flashcard dalam kategori ini' });
        }
      },
      error: (err) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Gagal memuat flashcard' });
        console.error('Error loading flashcards:', err);
      }
    });
  }

  get currentFlashcard(): Flashcard | null {
    return this.filteredFlashcards[this.currentIndex] || null;
  }

  get currentCardCategoryName(): string {
    const card = this.currentFlashcard;
    if (!card) return '';
    if (card.category_name) return card.category_name;
    const catId = card.flashcard_category_id || (card as any).category_id || (card as any).ID_CATEGORY || (card as any).flashcard_category_ID;
    if (catId !== undefined && catId !== null) {
      const found = this.categories.find(c => String(c.id) === String(catId));
      if (found) return found.name;
    }
    if (card.topic) return card.topic;
    if (this.selectedCategory && this.selectedCategory.name !== 'Custom Session') {
      return this.selectedCategory.name;
    }
    return '';
  }

  get progressPercentage(): number {
    if (this.filteredFlashcards.length === 0) return 0;
    return ((this.currentIndex + 1) / this.filteredFlashcards.length) * 100;
  }

  updateCurrentImages(): void {
    const flashcard = this.currentFlashcard;
    if (!flashcard) {
      this.questionImages = [];
      this.answerImages = [];
      return;
    }
    if (flashcard.question_images && flashcard.question_images.length > 0) {
      this.questionImages = flashcard.question_images.map(img => img.image_path);
    } else {
      this.questionImages = flashcard.question_image_path ? [flashcard.question_image_path] : [];
    }

    if (flashcard.images && flashcard.images.length > 0) {
      this.answerImages = flashcard.images.map(img => img.image_path);
    } else {
      this.answerImages = flashcard.image_path ? [flashcard.image_path] : [];
    }
  }

  updateUserAnswerText(): void {
    const flashcard = this.currentFlashcard;
    this.userAnswerText = flashcard?.answer || '';
    this.revealedOcclusions = {};

    if (this.isOcclusionCard) {
      try {
        this.occlusions = JSON.parse(flashcard?.description || '[]') || [];
      } catch (e) {
        this.occlusions = [];
      }

      // Load user's saved answer labels if any
      try {
        this.userAnswerLabels = JSON.parse(flashcard?.answer || '[]');
      } catch (e) {
        this.userAnswerLabels = [];
      }

      // Ensure the array has the correct size
      if (this.userAnswerLabels.length !== this.occlusions.length) {
        const temp = new Array(this.occlusions.length).fill('');
        this.userAnswerLabels.forEach((val, i) => {
          if (i < temp.length) temp[i] = val;
        });
        this.userAnswerLabels = temp;
      }
    } else {
      this.occlusions = [];
      this.userAnswerLabels = [];
    }

    // Normalize status from database lowercase format ('ulang', 'sulit', etc.) to UI Title Case format
    const status = flashcard?.answer_status?.toLowerCase();
    if (status === 'ulang') {
      this.selectedRating = 'Ulangi';
    } else if (status) {
      this.selectedRating = status.charAt(0).toUpperCase() + status.slice(1);
    } else {
      this.selectedRating = 'Baik';
    }
  }

  getSafeHtml(html: string | null | undefined): any {
    if (!html) return '';
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  flipCard(): void {
    this.isFlipped = !this.isFlipped;
    if (!this.isFlipped) {
      this.revealedOcclusions = {};
    }
  }

  /** Called when clicking the front card — flips to answer side */
  flipToAnswer(): void {
    if (!this.isFlipped) {
      this.isFlipped = true;
      this.resetCardScroll();
    }
  }

  /** Called when clicking the back card — flips back to question side */
  flipToQuestion(): void {
    if (this.isFlipped) {
      this.isFlipped = false;
      this.revealedOcclusions = {};
      this.resetCardScroll();
    }
  }

  revealOcclusion(idx: number, event: Event): void {
    event.stopPropagation();
    this.revealedOcclusions[idx] = !this.revealedOcclusions[idx];
  }

  /** Select thumbnail on the question (front) side without flipping the card */
  selectQuestionImage(idx: number, event: Event): void {
    event.stopPropagation();
    this.activeQuestionImgIndex = idx;
  }

  /** Select thumbnail on the answer (back) side without flipping the card */
  selectAnswerImage(idx: number, event: Event): void {
    event.stopPropagation();
    this.activeAnswerImgIndex = idx;
  }

  resetImageIndices(): void {
    this.activeQuestionImgIndex = 0;
    this.activeAnswerImgIndex = 0;
  }

  cacheCurrentAnswer(): void {
    const flashcard = this.currentFlashcard;
    if (flashcard) {
      if (flashcard.type === 'image') {
        flashcard.answer = JSON.stringify(this.userAnswerLabels);
      } else {
        flashcard.answer = this.userAnswerText;
      }
      let payloadStatus = this.selectedRating.toLowerCase();
      if (payloadStatus === 'ulangi') {
        payloadStatus = 'ulang';
      }
      flashcard.answer_status = payloadStatus;
    }
  }

  nextCard(event?: Event): void {
    if (event) event.stopPropagation();

    const flashcard = this.currentFlashcard;
    if (flashcard && this.userId) {
      // Map rating to lowercase, and map Ulangi to ulang
      let payloadStatus = (this.selectedRating || 'Baik').toLowerCase();
      if (payloadStatus === 'ulangi') {
        payloadStatus = 'ulang';
      }

      // Cache locally immediately
      const answerPayload = flashcard.type === 'image' ? JSON.stringify(this.userAnswerLabels) : (this.userAnswerText || '');
      flashcard.answer = answerPayload;
      flashcard.answer_status = payloadStatus;

      this.flashcardService.saveAnswer(Number(flashcard.id), this.userId, answerPayload, payloadStatus).subscribe({
        next: (res) => {
          this.messageService.add({ severity: 'success', summary: 'Sukses', detail: 'Jawaban berhasil disimpan' });
          this.handleNextNavigation();
        },
        error: (err) => {
          console.error('Error saving flashcard answer:', err);
          this.messageService.add({ severity: 'warn', summary: 'Perhatian', detail: 'Gagal mengirim rating ke server, melanjutkan.' });
          this.handleNextNavigation();
        }
      });
      return;
    }

    this.handleNextNavigation();
  }

  handleNextNavigation(): void {
    if (this.currentIndex === this.filteredFlashcards.length - 1) {
      this.messageService.add({
        severity: 'success',
        summary: 'Selesai!',
        detail: 'Selamat, Anda telah menyelesaikan seluruh kartu pada sesi belajar ini.'
      });
      this.changeCategory();
    } else {
      this.advanceCard();
    }
  }

  advanceCard(): void {
    if (this.currentIndex < this.filteredFlashcards.length - 1) {
      this.cacheCurrentAnswer();
      this.currentIndex++;
      this.isFlipped = false;
      this.selectedRating = 'Baik'; // Reset default rating for the next card
      this.resetImageIndices();
      this.updateCurrentImages();
      this.updateUserAnswerText();
      this.resetCardScroll();
    }
  }

  previousCard(event?: Event): void {
    if (event) event.stopPropagation();
    if (this.currentIndex > 0) {
      this.cacheCurrentAnswer();
      this.currentIndex--;
      this.isFlipped = false;
      this.resetImageIndices();
      this.updateCurrentImages();
      this.updateUserAnswerText();
      this.resetCardScroll();
    }
  }

  prevCard(event?: Event): void {
    this.previousCard(event);
  }

  goToCard(index: number, event?: Event): void {
    if (event) event.stopPropagation();
    this.cacheCurrentAnswer();
    this.currentIndex = index;
    this.isFlipped = false;
    this.resetImageIndices();
    this.updateCurrentImages();
    this.updateUserAnswerText();
    this.resetCardScroll();
  }

  onSearchChange(): void {
    this.cacheCurrentAnswer();
    this.currentIndex = 0;
    this.isFlipped = false;
    this.resetImageIndices();
    this.updateCurrentImages();
    this.updateUserAnswerText();
  }

  getImageUrl(imagePath: string): string {
    if (!imagePath) return '';
    return `https://oscemediko.id/api-timer/${imagePath}`;
  }

  viewImage(url: string): void {
    this.selectedImageUrl = url;
    this.displayImageDialog = true;
  }

  sanitizeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  selectRating(status: string): void {
    this.selectedRating = status;
  }

  changeCategory(): void {
    this.isFullscreen = false;
    this.updateFullscreenClass();
    this.resetState();
    this.loadCategories();
    this.router.navigate(['/app/flashcard/show']);
  }
}